var __create = Object.create;
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, {
  enumerable: true,
  configurable: true,
  writable: true,
  value
}) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {})) if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols) for (var prop of __getOwnPropSymbols(b)) {
    if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source) if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols) for (var prop of __getOwnPropSymbols(source)) {
    if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop)) target[prop] = source[prop];
  }
  return target;
};
var __commonJS = (cb, mod) => function __require() {
  return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = {
    exports: {}
  }).exports, mod), mod.exports;
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from)) if (!__hasOwnProp.call(to, key) && key !== except) __defProp(to, key, {
      get: () => from[key],
      enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
    });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
// If the importer is in node compatibility mode or this is not an ESM
// file that has been converted to a CommonJS file using a Babel-
// compatible transform (i.e. "__esModule" has not been set), then set
// "default" to the CommonJS "module.exports" for node compatibility.
isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", {
  value: mod,
  enumerable: true
}) : target, mod));

// ../../../../node_modules/.pnpm/lodash.isequal@4.5.0/node_modules/lodash.isequal/index.js
var require_lodash = __commonJS({
  "../../../../node_modules/.pnpm/lodash.isequal@4.5.0/node_modules/lodash.isequal/index.js"(exports, module) {
    var LARGE_ARRAY_SIZE = 200;
    var HASH_UNDEFINED = "__lodash_hash_undefined__";
    var COMPARE_PARTIAL_FLAG = 1;
    var COMPARE_UNORDERED_FLAG = 2;
    var MAX_SAFE_INTEGER = 9007199254740991;
    var argsTag = "[object Arguments]";
    var arrayTag = "[object Array]";
    var asyncTag = "[object AsyncFunction]";
    var boolTag = "[object Boolean]";
    var dateTag = "[object Date]";
    var errorTag = "[object Error]";
    var funcTag = "[object Function]";
    var genTag = "[object GeneratorFunction]";
    var mapTag = "[object Map]";
    var numberTag = "[object Number]";
    var nullTag = "[object Null]";
    var objectTag = "[object Object]";
    var promiseTag = "[object Promise]";
    var proxyTag = "[object Proxy]";
    var regexpTag = "[object RegExp]";
    var setTag = "[object Set]";
    var stringTag = "[object String]";
    var symbolTag = "[object Symbol]";
    var undefinedTag = "[object Undefined]";
    var weakMapTag = "[object WeakMap]";
    var arrayBufferTag = "[object ArrayBuffer]";
    var dataViewTag = "[object DataView]";
    var float32Tag = "[object Float32Array]";
    var float64Tag = "[object Float64Array]";
    var int8Tag = "[object Int8Array]";
    var int16Tag = "[object Int16Array]";
    var int32Tag = "[object Int32Array]";
    var uint8Tag = "[object Uint8Array]";
    var uint8ClampedTag = "[object Uint8ClampedArray]";
    var uint16Tag = "[object Uint16Array]";
    var uint32Tag = "[object Uint32Array]";
    var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
    var reIsHostCtor = /^\[object .+?Constructor\]$/;
    var reIsUint = /^(?:0|[1-9]\d*)$/;
    var typedArrayTags = {};
    typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
    typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
    var freeGlobal = typeof global == "object" && global && global.Object === Object && global;
    var freeSelf = typeof self == "object" && self && self.Object === Object && self;
    var root = freeGlobal || freeSelf || Function("return this")();
    var freeExports = typeof exports == "object" && exports && !exports.nodeType && exports;
    var freeModule = freeExports && typeof module == "object" && module && !module.nodeType && module;
    var moduleExports = freeModule && freeModule.exports === freeExports;
    var freeProcess = moduleExports && freeGlobal.process;
    var nodeUtil = function () {
      try {
        return freeProcess && freeProcess.binding && freeProcess.binding("util");
      } catch (e) {}
    }();
    var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
    function arrayFilter(array, predicate) {
      var index = -1,
        length = array == null ? 0 : array.length,
        resIndex = 0,
        result = [];
      while (++index < length) {
        var value = array[index];
        if (predicate(value, index, array)) {
          result[resIndex++] = value;
        }
      }
      return result;
    }
    function arrayPush(array, values) {
      var index = -1,
        length = values.length,
        offset = array.length;
      while (++index < length) {
        array[offset + index] = values[index];
      }
      return array;
    }
    function arraySome(array, predicate) {
      var index = -1,
        length = array == null ? 0 : array.length;
      while (++index < length) {
        if (predicate(array[index], index, array)) {
          return true;
        }
      }
      return false;
    }
    function baseTimes(n, iteratee) {
      var index = -1,
        result = Array(n);
      while (++index < n) {
        result[index] = iteratee(index);
      }
      return result;
    }
    function baseUnary(func) {
      return function (value) {
        return func(value);
      };
    }
    function cacheHas(cache, key) {
      return cache.has(key);
    }
    function getValue(object, key) {
      return object == null ? void 0 : object[key];
    }
    function mapToArray(map) {
      var index = -1,
        result = Array(map.size);
      map.forEach(function (value, key) {
        result[++index] = [key, value];
      });
      return result;
    }
    function overArg(func, transform) {
      return function (arg) {
        return func(transform(arg));
      };
    }
    function setToArray(set) {
      var index = -1,
        result = Array(set.size);
      set.forEach(function (value) {
        result[++index] = value;
      });
      return result;
    }
    var arrayProto = Array.prototype;
    var funcProto = Function.prototype;
    var objectProto = Object.prototype;
    var coreJsData = root["__core-js_shared__"];
    var funcToString = funcProto.toString;
    var hasOwnProperty = objectProto.hasOwnProperty;
    var maskSrcKey = function () {
      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
      return uid ? "Symbol(src)_1." + uid : "";
    }();
    var nativeObjectToString = objectProto.toString;
    var reIsNative = RegExp("^" + funcToString.call(hasOwnProperty).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
    var Buffer2 = moduleExports ? root.Buffer : void 0;
    var Symbol2 = root.Symbol;
    var Uint8Array2 = root.Uint8Array;
    var propertyIsEnumerable = objectProto.propertyIsEnumerable;
    var splice = arrayProto.splice;
    var symToStringTag = Symbol2 ? Symbol2.toStringTag : void 0;
    var nativeGetSymbols = Object.getOwnPropertySymbols;
    var nativeIsBuffer = Buffer2 ? Buffer2.isBuffer : void 0;
    var nativeKeys = overArg(Object.keys, Object);
    var DataView = getNative(root, "DataView");
    var Map = getNative(root, "Map");
    var Promise2 = getNative(root, "Promise");
    var Set = getNative(root, "Set");
    var WeakMap = getNative(root, "WeakMap");
    var nativeCreate = getNative(Object, "create");
    var dataViewCtorString = toSource(DataView);
    var mapCtorString = toSource(Map);
    var promiseCtorString = toSource(Promise2);
    var setCtorString = toSource(Set);
    var weakMapCtorString = toSource(WeakMap);
    var symbolProto = Symbol2 ? Symbol2.prototype : void 0;
    var symbolValueOf = symbolProto ? symbolProto.valueOf : void 0;
    function Hash(entries) {
      var index = -1,
        length = entries == null ? 0 : entries.length;
      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }
    function hashClear() {
      this.__data__ = nativeCreate ? nativeCreate(null) : {};
      this.size = 0;
    }
    function hashDelete(key) {
      var result = this.has(key) && delete this.__data__[key];
      this.size -= result ? 1 : 0;
      return result;
    }
    function hashGet(key) {
      var data = this.__data__;
      if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? void 0 : result;
      }
      return hasOwnProperty.call(data, key) ? data[key] : void 0;
    }
    function hashHas(key) {
      var data = this.__data__;
      return nativeCreate ? data[key] !== void 0 : hasOwnProperty.call(data, key);
    }
    function hashSet(key, value) {
      var data = this.__data__;
      this.size += this.has(key) ? 0 : 1;
      data[key] = nativeCreate && value === void 0 ? HASH_UNDEFINED : value;
      return this;
    }
    Hash.prototype.clear = hashClear;
    Hash.prototype["delete"] = hashDelete;
    Hash.prototype.get = hashGet;
    Hash.prototype.has = hashHas;
    Hash.prototype.set = hashSet;
    function ListCache(entries) {
      var index = -1,
        length = entries == null ? 0 : entries.length;
      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }
    function listCacheClear() {
      this.__data__ = [];
      this.size = 0;
    }
    function listCacheDelete(key) {
      var data = this.__data__,
        index = assocIndexOf(data, key);
      if (index < 0) {
        return false;
      }
      var lastIndex = data.length - 1;
      if (index == lastIndex) {
        data.pop();
      } else {
        splice.call(data, index, 1);
      }
      --this.size;
      return true;
    }
    function listCacheGet(key) {
      var data = this.__data__,
        index = assocIndexOf(data, key);
      return index < 0 ? void 0 : data[index][1];
    }
    function listCacheHas(key) {
      return assocIndexOf(this.__data__, key) > -1;
    }
    function listCacheSet(key, value) {
      var data = this.__data__,
        index = assocIndexOf(data, key);
      if (index < 0) {
        ++this.size;
        data.push([key, value]);
      } else {
        data[index][1] = value;
      }
      return this;
    }
    ListCache.prototype.clear = listCacheClear;
    ListCache.prototype["delete"] = listCacheDelete;
    ListCache.prototype.get = listCacheGet;
    ListCache.prototype.has = listCacheHas;
    ListCache.prototype.set = listCacheSet;
    function MapCache(entries) {
      var index = -1,
        length = entries == null ? 0 : entries.length;
      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }
    function mapCacheClear() {
      this.size = 0;
      this.__data__ = {
        "hash": new Hash(),
        "map": new (Map || ListCache)(),
        "string": new Hash()
      };
    }
    function mapCacheDelete(key) {
      var result = getMapData(this, key)["delete"](key);
      this.size -= result ? 1 : 0;
      return result;
    }
    function mapCacheGet(key) {
      return getMapData(this, key).get(key);
    }
    function mapCacheHas(key) {
      return getMapData(this, key).has(key);
    }
    function mapCacheSet(key, value) {
      var data = getMapData(this, key),
        size = data.size;
      data.set(key, value);
      this.size += data.size == size ? 0 : 1;
      return this;
    }
    MapCache.prototype.clear = mapCacheClear;
    MapCache.prototype["delete"] = mapCacheDelete;
    MapCache.prototype.get = mapCacheGet;
    MapCache.prototype.has = mapCacheHas;
    MapCache.prototype.set = mapCacheSet;
    function SetCache(values) {
      var index = -1,
        length = values == null ? 0 : values.length;
      this.__data__ = new MapCache();
      while (++index < length) {
        this.add(values[index]);
      }
    }
    function setCacheAdd(value) {
      this.__data__.set(value, HASH_UNDEFINED);
      return this;
    }
    function setCacheHas(value) {
      return this.__data__.has(value);
    }
    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
    SetCache.prototype.has = setCacheHas;
    function Stack(entries) {
      var data = this.__data__ = new ListCache(entries);
      this.size = data.size;
    }
    function stackClear() {
      this.__data__ = new ListCache();
      this.size = 0;
    }
    function stackDelete(key) {
      var data = this.__data__,
        result = data["delete"](key);
      this.size = data.size;
      return result;
    }
    function stackGet(key) {
      return this.__data__.get(key);
    }
    function stackHas(key) {
      return this.__data__.has(key);
    }
    function stackSet(key, value) {
      var data = this.__data__;
      if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
          pairs.push([key, value]);
          this.size = ++data.size;
          return this;
        }
        data = this.__data__ = new MapCache(pairs);
      }
      data.set(key, value);
      this.size = data.size;
      return this;
    }
    Stack.prototype.clear = stackClear;
    Stack.prototype["delete"] = stackDelete;
    Stack.prototype.get = stackGet;
    Stack.prototype.has = stackHas;
    Stack.prototype.set = stackSet;
    function arrayLikeKeys(value, inherited) {
      var isArr = isArray(value),
        isArg = !isArr && isArguments(value),
        isBuff = !isArr && !isArg && isBuffer(value),
        isType = !isArr && !isArg && !isBuff && isTypedArray(value),
        skipIndexes = isArr || isArg || isBuff || isType,
        result = skipIndexes ? baseTimes(value.length, String) : [],
        length = result.length;
      for (var key in value) {
        if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && (
        // Safari 9 has enumerable `arguments.length` in strict mode.
        key == "length" ||
        // Node.js 0.10 has enumerable non-index properties on buffers.
        isBuff && (key == "offset" || key == "parent") ||
        // PhantomJS 2 has enumerable non-index properties on typed arrays.
        isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") ||
        // Skip index properties.
        isIndex(key, length)))) {
          result.push(key);
        }
      }
      return result;
    }
    function assocIndexOf(array, key) {
      var length = array.length;
      while (length--) {
        if (eq(array[length][0], key)) {
          return length;
        }
      }
      return -1;
    }
    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
      var result = keysFunc(object);
      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
    }
    function baseGetTag(value) {
      if (value == null) {
        return value === void 0 ? undefinedTag : nullTag;
      }
      return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
    }
    function baseIsArguments(value) {
      return isObjectLike(value) && baseGetTag(value) == argsTag;
    }
    function baseIsEqual(value, other, bitmask, customizer, stack) {
      if (value === other) {
        return true;
      }
      if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) {
        return value !== value && other !== other;
      }
      return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
    }
    function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
      var objIsArr = isArray(object),
        othIsArr = isArray(other),
        objTag = objIsArr ? arrayTag : getTag(object),
        othTag = othIsArr ? arrayTag : getTag(other);
      objTag = objTag == argsTag ? objectTag : objTag;
      othTag = othTag == argsTag ? objectTag : othTag;
      var objIsObj = objTag == objectTag,
        othIsObj = othTag == objectTag,
        isSameTag = objTag == othTag;
      if (isSameTag && isBuffer(object)) {
        if (!isBuffer(other)) {
          return false;
        }
        objIsArr = true;
        objIsObj = false;
      }
      if (isSameTag && !objIsObj) {
        stack || (stack = new Stack());
        return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
      }
      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, "__wrapped__"),
          othIsWrapped = othIsObj && hasOwnProperty.call(other, "__wrapped__");
        if (objIsWrapped || othIsWrapped) {
          var objUnwrapped = objIsWrapped ? object.value() : object,
            othUnwrapped = othIsWrapped ? other.value() : other;
          stack || (stack = new Stack());
          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
      }
      if (!isSameTag) {
        return false;
      }
      stack || (stack = new Stack());
      return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
    }
    function baseIsNative(value) {
      if (!isObject(value) || isMasked(value)) {
        return false;
      }
      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
      return pattern.test(toSource(value));
    }
    function baseIsTypedArray(value) {
      return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
    }
    function baseKeys(object) {
      if (!isPrototype(object)) {
        return nativeKeys(object);
      }
      var result = [];
      for (var key in Object(object)) {
        if (hasOwnProperty.call(object, key) && key != "constructor") {
          result.push(key);
        }
      }
      return result;
    }
    function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
        arrLength = array.length,
        othLength = other.length;
      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
        return false;
      }
      var stacked = stack.get(array);
      if (stacked && stack.get(other)) {
        return stacked == other;
      }
      var index = -1,
        result = true,
        seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache() : void 0;
      stack.set(array, other);
      stack.set(other, array);
      while (++index < arrLength) {
        var arrValue = array[index],
          othValue = other[index];
        if (customizer) {
          var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        }
        if (compared !== void 0) {
          if (compared) {
            continue;
          }
          result = false;
          break;
        }
        if (seen) {
          if (!arraySome(other, function (othValue2, othIndex) {
            if (!cacheHas(seen, othIndex) && (arrValue === othValue2 || equalFunc(arrValue, othValue2, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
            result = false;
            break;
          }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
          result = false;
          break;
        }
      }
      stack["delete"](array);
      stack["delete"](other);
      return result;
    }
    function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
      switch (tag) {
        case dataViewTag:
          if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) {
            return false;
          }
          object = object.buffer;
          other = other.buffer;
        case arrayBufferTag:
          if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array2(object), new Uint8Array2(other))) {
            return false;
          }
          return true;
        case boolTag:
        case dateTag:
        case numberTag:
          return eq(+object, +other);
        case errorTag:
          return object.name == other.name && object.message == other.message;
        case regexpTag:
        case stringTag:
          return object == other + "";
        case mapTag:
          var convert = mapToArray;
        case setTag:
          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
          convert || (convert = setToArray);
          if (object.size != other.size && !isPartial) {
            return false;
          }
          var stacked = stack.get(object);
          if (stacked) {
            return stacked == other;
          }
          bitmask |= COMPARE_UNORDERED_FLAG;
          stack.set(object, other);
          var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
          stack["delete"](object);
          return result;
        case symbolTag:
          if (symbolValueOf) {
            return symbolValueOf.call(object) == symbolValueOf.call(other);
          }
      }
      return false;
    }
    function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
        objProps = getAllKeys(object),
        objLength = objProps.length,
        othProps = getAllKeys(other),
        othLength = othProps.length;
      if (objLength != othLength && !isPartial) {
        return false;
      }
      var index = objLength;
      while (index--) {
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
          return false;
        }
      }
      var stacked = stack.get(object);
      if (stacked && stack.get(other)) {
        return stacked == other;
      }
      var result = true;
      stack.set(object, other);
      stack.set(other, object);
      var skipCtor = isPartial;
      while (++index < objLength) {
        key = objProps[index];
        var objValue = object[key],
          othValue = other[key];
        if (customizer) {
          var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        }
        if (!(compared === void 0 ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
          result = false;
          break;
        }
        skipCtor || (skipCtor = key == "constructor");
      }
      if (result && !skipCtor) {
        var objCtor = object.constructor,
          othCtor = other.constructor;
        if (objCtor != othCtor && "constructor" in object && "constructor" in other && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) {
          result = false;
        }
      }
      stack["delete"](object);
      stack["delete"](other);
      return result;
    }
    function getAllKeys(object) {
      return baseGetAllKeys(object, keys, getSymbols);
    }
    function getMapData(map, key) {
      var data = map.__data__;
      return isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
    }
    function getNative(object, key) {
      var value = getValue(object, key);
      return baseIsNative(value) ? value : void 0;
    }
    function getRawTag(value) {
      var isOwn = hasOwnProperty.call(value, symToStringTag),
        tag = value[symToStringTag];
      try {
        value[symToStringTag] = void 0;
        var unmasked = true;
      } catch (e) {}
      var result = nativeObjectToString.call(value);
      if (unmasked) {
        if (isOwn) {
          value[symToStringTag] = tag;
        } else {
          delete value[symToStringTag];
        }
      }
      return result;
    }
    var getSymbols = !nativeGetSymbols ? stubArray : function (object) {
      if (object == null) {
        return [];
      }
      object = Object(object);
      return arrayFilter(nativeGetSymbols(object), function (symbol) {
        return propertyIsEnumerable.call(object, symbol);
      });
    };
    var getTag = baseGetTag;
    if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map()) != mapTag || Promise2 && getTag(Promise2.resolve()) != promiseTag || Set && getTag(new Set()) != setTag || WeakMap && getTag(new WeakMap()) != weakMapTag) {
      getTag = function (value) {
        var result = baseGetTag(value),
          Ctor = result == objectTag ? value.constructor : void 0,
          ctorString = Ctor ? toSource(Ctor) : "";
        if (ctorString) {
          switch (ctorString) {
            case dataViewCtorString:
              return dataViewTag;
            case mapCtorString:
              return mapTag;
            case promiseCtorString:
              return promiseTag;
            case setCtorString:
              return setTag;
            case weakMapCtorString:
              return weakMapTag;
          }
        }
        return result;
      };
    }
    function isIndex(value, length) {
      length = length == null ? MAX_SAFE_INTEGER : length;
      return !!length && (typeof value == "number" || reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
    }
    function isKeyable(value) {
      var type = typeof value;
      return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
    }
    function isMasked(func) {
      return !!maskSrcKey && maskSrcKey in func;
    }
    function isPrototype(value) {
      var Ctor = value && value.constructor,
        proto = typeof Ctor == "function" && Ctor.prototype || objectProto;
      return value === proto;
    }
    function objectToString(value) {
      return nativeObjectToString.call(value);
    }
    function toSource(func) {
      if (func != null) {
        try {
          return funcToString.call(func);
        } catch (e) {}
        try {
          return func + "";
        } catch (e) {}
      }
      return "";
    }
    function eq(value, other) {
      return value === other || value !== value && other !== other;
    }
    var isArguments = baseIsArguments(/* @__PURE__ */function () {
      return arguments;
    }()) ? baseIsArguments : function (value) {
      return isObjectLike(value) && hasOwnProperty.call(value, "callee") && !propertyIsEnumerable.call(value, "callee");
    };
    var isArray = Array.isArray;
    function isArrayLike(value) {
      return value != null && isLength(value.length) && !isFunction(value);
    }
    var isBuffer = nativeIsBuffer || stubFalse;
    function isEqual2(value, other) {
      return baseIsEqual(value, other);
    }
    function isFunction(value) {
      if (!isObject(value)) {
        return false;
      }
      var tag = baseGetTag(value);
      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
    }
    function isLength(value) {
      return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
    }
    function isObject(value) {
      var type = typeof value;
      return value != null && (type == "object" || type == "function");
    }
    function isObjectLike(value) {
      return value != null && typeof value == "object";
    }
    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
    function keys(object) {
      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
    }
    function stubArray() {
      return [];
    }
    function stubFalse() {
      return false;
    }
    module.exports = isEqual2;
  }
});

// src/help-center-search.tsx
import React46, { useState as useState5 } from "react";
import { EGDSButtonSize as EGDSButtonSize7 } from "@egds/react-core/button";
import { EGDSSpacing as EGDSSpacing8 } from "@egds/react-core/spacing";
import { EGDSToolbar } from "@egds/react-core/toolbar";
import { ArticleContextProvider as ArticleContextProvider2 } from "@shared-ui/retail-help-center-help-articles";

// ../internal/src/components/egds-button/egds-button.tsx
import React3 from "react";
import { EGDSPrimaryButton, EGDSSecondaryButton, EGDSTertiaryButton } from "@egds/react-core/button";
import { gql as gql3 } from "@shared-ui/apollo-client-wrapper";

// ../internal/src/components/egds-graphic/egds-icon.tsx
import React from "react";
import { EGDSIcon, EGDSIconSize } from "@egds/react-core/icons";
import { gql } from "@shared-ui/apollo-client-wrapper";
var __EGDSIconFragment = gql`
  fragment EGDSIconFragment on Icon {
    description
    id
    size
    title
    theme
    spotLight
  }
`;
var mapSpotlight = spotlight => {
  if (!spotlight) {
    return void 0;
  }
  switch (spotlight) {
    case "STANDARD" /* STANDARD */:
      return "standard";
    case "POSITIVE" /* POSITIVE */:
      return "positive";
    case "WARNING" /* WARNING */:
      return "warning";
    case "INFO" /* INFO */:
      return "info";
    default:
      return void 0;
  }
};
var HelpCenterEGDSIcon = ({
  data,
  size
}) => {
  var _a, _b;
  const iconName = data ? data.id : "";
  const finalSize = size != null ? size : (data == null ? void 0 : data.size) && EGDSIconSize[data.size];
  const spotlight = data == null ? void 0 : data.spotLight;
  const title = (_a = data == null ? void 0 : data.title) != null ? _a : void 0;
  return /* @__PURE__ */React.createElement(EGDSIcon, {
    id: iconName,
    name: iconName,
    size: finalSize,
    title,
    theme: (_b = data == null ? void 0 : data.theme) != null ? _b : void 0,
    spotlight: mapSpotlight(spotlight)
  });
};
HelpCenterEGDSIcon.displayName = "HelpCenterEGDSIcon";
HelpCenterEGDSIcon.fragment = __EGDSIconFragment;

// ../internal/src/components/egds-graphic/egds-graphic.tsx
import React2 from "react";
import { gql as gql2 } from "@shared-ui/apollo-client-wrapper";
var __EGDSGraphicFragment = gql2`
  fragment EGDSGraphicFragment on UIGraphic {
    ... on Icon {
      ...EGDSIconFragment
    }
  }

  ${HelpCenterEGDSIcon.fragment}
`;
var EGDSGraphic = ({
  data
}) => {
  switch (data.__typename) {
    case "Icon":
      return /* @__PURE__ */React2.createElement(HelpCenterEGDSIcon, {
        data
      });
    default:
      return null;
  }
};
EGDSGraphic.displayName = "EGDSGraphic";
EGDSGraphic.fragment = __EGDSGraphicFragment;

// ../internal/src/components/egds-button/egds-button.tsx
var __fragment = gql3`
  fragment EGDSButtonFragment on EGDSButton {
    primary
    disabled
    icon {
      ...EGDSIconFragment
    }
    accessibility
  }
  ${HelpCenterEGDSIcon.fragment}
`;
var HelpCenterEGDSButton = _a => {
  var _b = _a,
    {
      data,
      onClickHandler,
      isDisabled,
      type,
      iconPosition = "LEADING" /* LEADING */
    } = _b,
    otherProps = __objRest(_b, ["data", "onClickHandler", "isDisabled", "type", "iconPosition"]);
  const {
    primary,
    disabled,
    accessibility,
    __typename,
    icon
  } = data;
  const buttonProps = {
    disabled: disabled || isDisabled,
    title: accessibility,
    type,
    onClick: onClickHandler
  };
  switch (__typename) {
    case "UIPrimaryButton":
      return /* @__PURE__ */React3.createElement(EGDSPrimaryButton, __spreadValues(__spreadValues({}, buttonProps), otherProps), icon && iconPosition === "LEADING" /* LEADING */ && /* @__PURE__ */React3.createElement(HelpCenterEGDSIcon, {
        data: icon
      }), primary, icon && iconPosition === "TRAILING" /* TRAILING */ && /* @__PURE__ */React3.createElement(HelpCenterEGDSIcon, {
        data: icon
      }));
    case "UISecondaryButton":
      return /* @__PURE__ */React3.createElement(EGDSSecondaryButton, __spreadValues(__spreadValues({}, buttonProps), otherProps), icon && iconPosition === "LEADING" /* LEADING */ && /* @__PURE__ */React3.createElement(HelpCenterEGDSIcon, {
        data: icon
      }), primary, icon && iconPosition === "TRAILING" /* TRAILING */ && /* @__PURE__ */React3.createElement(HelpCenterEGDSIcon, {
        data: icon
      }));
    case "UITertiaryButton":
      return /* @__PURE__ */React3.createElement(EGDSTertiaryButton, __spreadValues(__spreadValues({}, buttonProps), otherProps), icon && iconPosition === "LEADING" /* LEADING */ && /* @__PURE__ */React3.createElement(HelpCenterEGDSIcon, {
        data: icon
      }), primary, icon && iconPosition === "TRAILING" /* TRAILING */ && /* @__PURE__ */React3.createElement(HelpCenterEGDSIcon, {
        data: icon
      }));
    default:
      return null;
  }
};
HelpCenterEGDSButton.displayName = "HelpCenterEGDSButton";
HelpCenterEGDSButton.fragment = __fragment;

// ../internal/src/components/egds-text/egds-text.tsx
import React16 from "react";
import { gql as gql10 } from "@shared-ui/apollo-client-wrapper";

// ../internal/src/components/egds-text/egds-heading.tsx
import React4 from "react";
import { EGDSSpacing } from "@egds/react-core/spacing";
import { EGDSHeading } from "@egds/react-core/text";
import { gql as gql4 } from "@shared-ui/apollo-client-wrapper";
var fragment = gql4`
  fragment EGDSHeadingFragment on EGDSHeading {
    headingType
    text
  }
`;
var EGDSHeadingStyleMap = {
  ["H1" /* H1 */]: "h1",
  ["H2" /* H2 */]: "h2",
  ["H3" /* H3 */]: "h3",
  ["H4" /* H4 */]: "h4",
  ["H5" /* H5 */]: "h5",
  ["H6" /* H6 */]: "h6",
  ["H7" /* H7 */]: "h6",
  ["H8" /* H8 */]: "h6"
};
var EGDSHeadingSizeMap = {
  ["H1" /* H1 */]: 3,
  ["H2" /* H2 */]: 4,
  ["H3" /* H3 */]: 5,
  ["H4" /* H4 */]: 6,
  ["H5" /* H5 */]: 7,
  ["H6" /* H6 */]: 8,
  ["H7" /* H7 */]: 8,
  ["H8" /* H8 */]: 8
};
var HelpCenterEGDSHeading = ({
  data,
  size,
  margin,
  padding
}) => {
  const tag = data.headingType !== null ? EGDSHeadingStyleMap[data.headingType] : void 0;
  const headingSize = size != null ? size : data.headingType == null ? void 0 : EGDSHeadingSizeMap[data.headingType];
  const marginSize = margin != null ? margin : {
    blockstart: "two"
  };
  const paddingSize = padding != null ? padding : void 0;
  return /* @__PURE__ */React4.createElement(EGDSSpacing, {
    margin: marginSize,
    padding: paddingSize
  }, /* @__PURE__ */React4.createElement(EGDSHeading, {
    tag,
    size: headingSize
  }, data.text));
};
HelpCenterEGDSHeading.fragment = fragment;
HelpCenterEGDSHeading.displayName = "HelpCenterEGDSHeading";

// ../internal/src/components/egds-text/egds-paragraph.tsx
import React5 from "react";
import { EGDSParagraph } from "@egds/react-core/text";
import { gql as gql5 } from "@shared-ui/apollo-client-wrapper";
var fragment2 = gql5`
  fragment EGDSParagraphFragment on EGDSParagraph {
    text
    style
  }
`;
var EGDSParagraphSizeMap = {
  ["P1" /* P1 */]: 1,
  ["P2" /* P2 */]: 2,
  ["P3" /* P3 */]: 3
};
var HelpCenterEGDSParagraph = ({
  data
}) => {
  return /* @__PURE__ */React5.createElement(EGDSParagraph, {
    size: EGDSParagraphSizeMap[data.style]
  }, data.text);
};
HelpCenterEGDSParagraph.fragment = fragment2;
HelpCenterEGDSParagraph.displayName = "HelpCenterEGDSParagraph";

// ../internal/src/components/egds-text/egds-plain-text.tsx
import React6 from "react";
import { EGDSText } from "@egds/react-core/text";
import { gql as gql6 } from "@shared-ui/apollo-client-wrapper";
var fragment3 = gql6`
  fragment EGDSPlainTextFragment on EGDSPlainText {
    text
  }
`;
var EGDSPlainText = ({
  data,
  align,
  inline,
  size
}) => /* @__PURE__ */React6.createElement(EGDSText, {
  align,
  inline,
  size,
  spacing: "two"
}, data.text);
EGDSPlainText.fragment = fragment3;
EGDSPlainText.displayName = "EGDSPlainText";

// ../internal/src/components/egds-text/egds-spannable-text.tsx
import React15 from "react";
import { EGDSParagraph as EGDSParagraph2 } from "@egds/react-core/text";
import { gql as gql9 } from "@shared-ui/apollo-client-wrapper";

// ../internal/src/components/egds-text/egds-inline-link.tsx
import React13 from "react";
import { gql as gql7 } from "@shared-ui/apollo-client-wrapper";
import { Experiment, ExperimentControl, ExperimentVariant } from "@shared-ui/experiment-context";

// ../internal/src/components/egds-text/egds-inline-link-control.tsx
import React11, { useCallback } from "react";
import { EGDSLink } from "@egds/react-core/link";
import { useEgClickstream } from "@shared-ui/clickstream-analytics-context";
import { useExperiment as useExperiment2 } from "@shared-ui/experiment-context";

// ../internal/src/utils/constants.ts
var EVENT_TYPE = "Interaction";
var EVENT_CATEGORY = "help_center";
var EVENT_VERSION = "1.2.0";
var PAGE_NAME = "Help Articles";
var PAGE_NAME_DETAILED = "Help Articles";
var APP_NAME = "ecp-help-center";
var APP_VERSION = "1.0.0";
var HOME_PAGE = "home_page";
var ARTICLE_DIALOG = "article_dialog";
var EVENT_NAME = "help_article_link.selected";
var CONTACT_US_ARTICLE_LINK_TYPE = "Contact Us";
var HELP_ARTICLE_SEARCH_SUBMITTED = "help_article_search.submitted";
var HELP_ARTICLE_SEARCH_EVENT_VERSION = "1.6.1";
var ARTICLE_GROUP_FROM_SEARCH_BAR = "search";
var ARTICLE_GROUP_FROM_EXTERNAL_LINK = "From External";

// ../help-articles/src/utils/eg-clickstream-helper.ts
var buildClickstreamAnalyticsForExternalArticles = (articleLink, articleLinkType, articleName, articleGroup, searchTerm) => {
  return {
    event: {
      event_name: EVENT_NAME,
      event_version: EVENT_VERSION,
      event_type: EVENT_TYPE,
      event_category: EVENT_CATEGORY,
      action_location: ARTICLE_DIALOG
    },
    article: {
      article_name: articleName,
      article_group: articleGroup,
      article_link: articleLink,
      article_link_type: articleLinkType,
      search_term: searchTerm
    },
    experience: {
      page_name: PAGE_NAME,
      app_name: APP_NAME,
      app_version: APP_VERSION,
      page_name_detailed: PAGE_NAME_DETAILED
    }
  };
};
var getArticleGroup = articleInfo => {
  const {
    product,
    searchTerm
  } = articleInfo;
  if (!product && searchTerm) {
    return ARTICLE_GROUP_FROM_SEARCH_BAR;
  }
  if (!product && !searchTerm) {
    return ARTICLE_GROUP_FROM_EXTERNAL_LINK;
  }
  return product || "";
};

// ../help-articles/src/components/help-articles/context/article-context.tsx
var import_lodash = __toESM(require_lodash());
import React9, { createContext as createContext3, useContext as useContext3, useState } from "react";
import { useDialog } from "@shared-ui/dialog-context";
import { useExperiment } from "@shared-ui/experiment-context";

// ../../../../node_modules/.pnpm/@shared-ui+logger-context@0.0.4_react@18.3.1/node_modules/@shared-ui/logger-context/dist/esmodule/logger-context.js
import * as React7 from "react";

// ../../../../node_modules/.pnpm/@shared-ui+logger-context@0.0.4_react@18.3.1/node_modules/@shared-ui/logger-context/dist/esmodule/components/system-event.js
var SystemEventLevel;
(function (SystemEventLevel2) {
  SystemEventLevel2["CRITICAL"] = "CRITICAL";
  SystemEventLevel2["ERROR"] = "ERROR";
  SystemEventLevel2["WARN"] = "WARN";
  SystemEventLevel2["INFO"] = "INFO";
  SystemEventLevel2["UNKNOWN"] = "UNKNOWN";
})(SystemEventLevel || (SystemEventLevel = {}));
var SystemEvent = /** @class */
function () {
  function SystemEvent2(level, name) {
    this.level = level;
    this.name = name;
  }
  SystemEvent2.prototype.toString = function () {
    return "SystemEvent(level=" + this.level.toString() + " name=" + this.name + ")";
  };
  return SystemEvent2;
}();

// ../../../../node_modules/.pnpm/@shared-ui+logger-context@0.0.4_react@18.3.1/node_modules/@shared-ui/logger-context/dist/esmodule/components/logger.js
var __read = function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
var __spread = function () {
  for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
  return ar;
};
var Logger = /** @class */
/* @__PURE__ */function () {
  function Logger2(logger) {
    var _this = this;
    this.event = logger.event || function () {};
    var logAtLevel = function (level, message) {
      var args = [];
      for (var _i = 2; _i < arguments.length; _i++) {
        args[_i - 2] = arguments[_i];
      }
      if (_this.event) {
        _this.event.apply(_this, __spread([new SystemEvent(level, message)], args));
      }
    };
    this.info = logger.info || function (message) {
      var args = [];
      for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
      }
      return logAtLevel.apply(void 0, __spread([SystemEventLevel.INFO, message], args));
    };
    this.warning = logger.warning || function (message) {
      var args = [];
      for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
      }
      return logAtLevel.apply(void 0, __spread([SystemEventLevel.WARN, message], args));
    };
    this.error = logger.error || function (message) {
      var args = [];
      for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
      }
      return logAtLevel.apply(void 0, __spread([SystemEventLevel.ERROR, message], args));
    };
  }
  return Logger2;
}();

// ../../../../node_modules/.pnpm/@shared-ui+logger-context@0.0.4_react@18.3.1/node_modules/@shared-ui/logger-context/dist/esmodule/logger-context.js
var defaults = new Logger({});
var LoggerContext = React7.createContext(defaults);
var LoggerProvider = function (props) {
  var logger = props.logger,
    children = props.children;
  var value = logger ? new Logger(logger) : defaults;
  return React7.createElement(LoggerContext.Provider, {
    value
  }, children || null);
};
LoggerProvider.displayName = "LoggerProvider";

// ../internal/src/utils/logger-events.ts
var EVENTS = {
  HELP_ARTICLE_FEEDBACK_SUBMIT: new SystemEvent(SystemEventLevel.INFO, "HELP_ARTICLE_FEEDBACK_SUBMIT")
};

// ../help-articles/src/utils/logger-events.ts
var EVENTS2 = {
  CLICK_MORE_LINK_INFO: new SystemEvent(SystemEventLevel.INFO, "CLICKED_MORE_LINK_INFO"),
  CLICK_ARTICLE_LINK_INFO: new SystemEvent(SystemEventLevel.INFO, "CLICKED_ARTICLE_LINK_INFO"),
  ARTICLE_DATA_LOADING_ERROR: new SystemEvent(SystemEventLevel.ERROR, "ARTICLE_DATA_LOADING_ERROR"),
  ARTICLE_LOG_INFO: new SystemEvent(SystemEventLevel.INFO, "ARTICLE_LOG_INFO"),
  MORE_ARTICLE_DATA_LOADING_ERROR: new SystemEvent(SystemEventLevel.ERROR, "MORE_ARTICLE_DATA_LOADING_ERROR"),
  SEARCH_ARTICLE_DATA_LOADING_ERROR: new SystemEvent(SystemEventLevel.ERROR, "SEARCH_ARTICLE_DATA_LOADING_ERROR"),
  SEARCH_ARTICLE_WARN: new SystemEvent(SystemEventLevel.WARN, "SEARCH_ARTICLE_WARN"),
  ALL_ARTICLE_DATA_LOADING_ERROR: new SystemEvent(SystemEventLevel.ERROR, "ALL_ARTICLE_DATA_LOADING_ERROR"),
  TYPEAHEAD_SUGGESTION_INFO: new SystemEvent(SystemEventLevel.INFO, "TYPEAHEAD_SUGGESTION_INFO"),
  HELP_ARTICLE_FEEDBACK_SUBMIT: new SystemEvent(SystemEventLevel.INFO, "HELP_ARTICLE_FEEDBACK_SUBMIT"),
  HELP_ARTICLE_FEEDBACK_LOADING_ERROR: new SystemEvent(SystemEventLevel.ERROR, "HELP_ARTICLE_FEEDBACK_LOADING_ERROR")
};

// ../help-articles/src/components/help-articles/context/caller-context.tsx
import { createContext as createContext2, useContext as useContext2 } from "react";
var defaultCallerContextValue = {
  callerContext: 0 /* HELP_CENTER */,
  callerContextCallback: () => {
    console.error("caller context's handler not set");
  }
};
var CallerContext = createContext2(defaultCallerContextValue);
var useCallerContext = () => useContext2(CallerContext);

// ../help-articles/src/components/help-articles/context/article-context.tsx
var defaultArticleContextValue = {
  triggerRef: null,
  setTriggerRef: () => {
    console.error("Current button`s ref not set!");
  },
  articleIdentifier: {},
  setArticleIdentifier: () => {
    console.error("Article Search callback not set!!");
  },
  isArticleDialogOpen: false,
  actionLocation: "",
  articleDialogActions: {
    openDialog: () => console.error("Article Dialog not yet initialized"),
    closeDialog: () => console.error("Article Dialog not yet initialized"),
    toggleDialog: () => console.error("Article Dialog not yet initialized")
  },
  ArticleDialogComponent: (/* istanbul ignore next -- @preserve */
  () => null),
  previousArticleId: "",
  setPreviousArticleId: () => {
    console.error("Previous article id not set!!");
  },
  preFillContactUsForm: {
    phoneNumber: "",
    itineraryNumber: "",
    category: "",
    intent: ""
  },
  setPreFillContactUsForm: () => {
    console.error("Pre fill contact us form not set!!");
  },
  articleLink: "",
  isContactUsDialogOpen: false,
  contactUsDialogActions: {
    openDialog: () => console.error("Contact us Dialog not yet initialized"),
    closeDialog: () => console.error("Contact us Dialog not yet initialized"),
    toggleDialog: () => console.error("Contact us Dialog not yet initialized")
  },
  ContactUsDialogComponent: (/* istanbul ignore next -- @preserve */
  () => null),
  shouldShowSideSheet: false,
  setShouldShowSideSheet: () => {
    console.error("shouldShowSideSheet not set!!");
  }
};
var ArticleContext = createContext3(defaultArticleContextValue);
var useArticle = () => useContext3(ArticleContext);

// ../help-articles/src/components/help-articles/context/help-articles-query-param-context.tsx
import React10 from "react";
var HelpArticleURLQueryParamsContext = React10.createContext({
  articleId: "",
  product: "",
  isCategory: false
});

// ../internal/src/components/egds-text/egds-inline-link-control.tsx
var EGDSInlineLinkControl = ({
  data,
  inline,
  onLinkClickHandler
}) => {
  const {
    setArticleIdentifier,
    articleIdentifier,
    contactUsDialogActions,
    articleDialogActions
  } = useArticle();
  const {
    callerContext
  } = useCallerContext();
  const isArticle = data.action.resource.value.includes("#/link") || data.action.resource.value.includes("#/article") && !data.action.resource.value.includes("taapacademy.expediapartnersolutions.com");
  const isContactUs = data.action.resource.value.includes("contact-us");
  const isNewContactUsExperience = useExperiment2("Contact_Us_Redesign_MVP_BEX_HCOM").exposure.bucket === 1;
  const onClick = useCallback((articleIdInfo, articleLink) => {
    setArticleIdentifier({
      articleLink,
      articleIdentifier: __spreadProps(__spreadValues({}, articleIdentifier), {
        articleId: articleIdInfo
      })
    });
  }, [articleIdentifier, setArticleIdentifier]);
  const onContactUsLinkClick = event => {
    if (onLinkClickHandler && typeof onLinkClickHandler === "function") {
      onLinkClickHandler(event);
    }
  };
  const track = useEgClickstream();
  const onClickCapture = (articleLinkType, searchTerm) => {
    const articleGroup = getArticleGroup({
      product: articleIdentifier.product,
      searchTerm: articleIdentifier.searchTerm
    });
    track(buildClickstreamAnalyticsForExternalArticles(data.action.resource.value, articleLinkType, data.text, articleGroup, searchTerm));
  };
  if (isArticle) {
    const articleIdInfo = data.action.resource.value.substr(data.action.resource.value.lastIndexOf("/") + 1);
    return /* @__PURE__ */React11.createElement(EGDSLink, {
      inline,
      key: data.text
    }, /* @__PURE__ */React11.createElement("button", {
      type: "button",
      onClick: () => onClick(articleIdInfo, data.action.resource.value)
    }, data.text));
  }
  if (isContactUs) {
    return /* @__PURE__ */React11.createElement(EGDSLink, {
      inline,
      key: data.text
    }, !isNewContactUsExperience && /* @__PURE__ */React11.createElement("button", {
      type: "button",
      onClick: () => {
        articleDialogActions.closeDialog();
        setTimeout(() => contactUsDialogActions.openDialog(), 100);
      },
      onClickCapture: () => onClickCapture(CONTACT_US_ARTICLE_LINK_TYPE, articleIdentifier.searchTerm)
    }, data.text), isNewContactUsExperience && /* @__PURE__ */React11.createElement("a", {
      href: "/contact-us",
      rel: "noopener",
      key: data.action.resource.value,
      onClick: onContactUsLinkClick,
      onClickCapture: () => onClickCapture(CONTACT_US_ARTICLE_LINK_TYPE, articleIdentifier.searchTerm),
      target: data.action.target === "EXTERNAL" /* EXTERNAL */ ? "_blank" : "_self"
    }, data.text));
  }
  return /* @__PURE__ */React11.createElement(EGDSLink, {
    inline,
    key: data.text
  }, /* @__PURE__ */React11.createElement("a", {
    href: data.action.resource.value,
    rel: "noopener",
    key: data.action.resource.value,
    onClickCapture: () => onClickCapture(data.action.target.valueOf(), articleIdentifier.searchTerm),
    target: callerContext === 1 /* QnA */ ? "_blank" : "_self"
  }, data.text));
};
EGDSInlineLinkControl.displayName = "EGDSInlineLinkControl";

// ../internal/src/components/egds-text/egds-inline-link-variant.tsx
import React12 from "react";
import { EGDSLink as EGDSLink2 } from "@egds/react-core/link";
var EGDSInlineLinkVariant = ({
  data,
  inline,
  onLinkClickHandler
}) => {
  const onLinkClick = event => {
    if (onLinkClickHandler && typeof onLinkClickHandler === "function") {
      onLinkClickHandler(event);
    }
  };
  return /* @__PURE__ */React12.createElement(EGDSLink2, {
    inline,
    key: data.text
  }, /* @__PURE__ */React12.createElement("a", {
    href: data.action.resource.value,
    rel: "noopener",
    key: data.action.resource.value,
    onClick: onLinkClick,
    target: data.action.target === "EXTERNAL" /* EXTERNAL */ ? "_blank" : "_self"
  }, data.text));
};
EGDSInlineLinkVariant.displayName = "EGDSInlineLinkVariant";

// ../internal/src/components/egds-text/egds-inline-link.tsx
var fragment4 = gql7`
  fragment EGDSInlineLinkFragment on EGDSInlineLink {
    text
    action {
      target
      resource {
        value
      }
      accessibility
    }
  }
`;
var EGDSInlineLink = ({
  data,
  inline,
  onLinkClickHandler
}) => {
  return /* @__PURE__ */React13.createElement(Experiment, {
    name: "HELPCENTER_ARTICLE_LINK_FIX"
  }, /* @__PURE__ */React13.createElement(ExperimentControl, null, /* @__PURE__ */React13.createElement(EGDSInlineLinkControl, __spreadValues({}, {
    data,
    inline,
    onLinkClickHandler
  }))), /* @__PURE__ */React13.createElement(ExperimentVariant, {
    bucket: 1
  }, /* @__PURE__ */React13.createElement(EGDSInlineLinkVariant, __spreadValues({}, {
    data,
    inline,
    onLinkClickHandler
  }))));
};
EGDSInlineLink.fragment = fragment4;
EGDSInlineLink.displayName = "EGDSInlineLink";

// ../internal/src/components/egds-text/egds-stylized-text.tsx
import React14 from "react";
import { EGDSText as EGDSText2 } from "@egds/react-core/text";
import { gql as gql8 } from "@shared-ui/apollo-client-wrapper";
var fragment5 = gql8`
  fragment EGDSStylizedTextFragment on EGDSStylizedText {
    text
    weight
  }
`;
var EGDSTextWeightMap = Object.freeze({
  ["BOLD" /* BOLD */]: "bold",
  ["MEDIUM" /* MEDIUM */]: "medium",
  ["REGULAR" /* REGULAR */]: "regular"
});
var EGDSStylizedText = ({
  data,
  inline
}) => /* @__PURE__ */React14.createElement(EGDSText2, {
  weight: data.weight ? EGDSTextWeightMap[data.weight] : void 0,
  inline,
  spacing: "two"
}, data.text);
EGDSStylizedText.fragment = fragment5;
EGDSStylizedText.displayName = "EGDSStylizedText";

// ../internal/src/components/egds-text/egds-spannable-text.tsx
var fragment6 = gql9`
  fragment EGDSSpannableTextFragment on EGDSSpannableText {
    contents {
      ...EGDSPlainTextFragment
      ...EGDSStylizedTextFragment
      ...EGDSInlineLinkFragment
    }
  }
  ${EGDSPlainText.fragment}
  ${EGDSStylizedText.fragment}
  ${EGDSInlineLink.fragment}
`;
var SpannableTextComponentMap = {
  EGDSPlainText,
  EGDSStylizedText,
  EGDSInlineLink
};
var SpannableTextComponentStyleMap = {
  EGDSPlainText: {
    inline: true
  },
  EGDSStylizedText: {
    inline: true
  },
  EGDSInlineLink: {
    inline: true
  }
};
var EGDSSpannableText = ({
  data,
  onLinkClickHandler
}) => {
  var _a;
  return /* @__PURE__ */React15.createElement(EGDSParagraph2, null, /* @__PURE__ */React15.createElement("span", null, (_a = data.contents) == null ? void 0 : _a.map((element, index) => {
    const SpannableTextComponent = SpannableTextComponentMap[element.__typename];
    if (!SpannableTextComponent) {
      return null;
    }
    if (element.__typename === "EGDSInlineLink") {
      return /* @__PURE__ */React15.createElement(SpannableTextComponent, __spreadValues(__spreadValues({
        data: element,
        key: index
      }, SpannableTextComponentStyleMap[element.__typename]), {
        onLinkClickHandler
      }));
    }
    return /* @__PURE__ */React15.createElement(SpannableTextComponent, __spreadValues({
      data: element,
      key: index
    }, SpannableTextComponentStyleMap[element.__typename]));
  })));
};
EGDSSpannableText.fragment = fragment6;
EGDSSpannableText.displayName = "EGDSSpannableText";

// ../internal/src/components/egds-text/egds-text.tsx
var fragment7 = gql10`
  fragment EGDSTextFragment on EGDSText {
    ...EGDSHeadingFragment
    ...EGDSParagraphFragment
    ...EGDSSpannableTextFragment
    ...EGDSPlainTextFragment
  }
  ${HelpCenterEGDSParagraph.fragment}
  ${EGDSPlainText.fragment}
  ${HelpCenterEGDSHeading.fragment}
  ${EGDSSpannableText.fragment}
`;
var TextComponentMap = {
  EGDSParagraph: HelpCenterEGDSParagraph,
  EGDSHeading: HelpCenterEGDSHeading,
  EGDSSpannableText,
  EGDSPlainText
};
var HelpCenterEGDSText = ({
  data,
  align
}) => {
  const TextComponent = TextComponentMap[data.__typename];
  if (!TextComponent) {
    return null;
  }
  return /* @__PURE__ */React16.createElement(TextComponent, {
    align,
    data
  });
};
HelpCenterEGDSText.fragment = fragment7;
HelpCenterEGDSText.displayName = "HelpCenterEGDSText";

// ../internal/src/components/egds-text/egds-graphic-text.tsx
import React17 from "react";
import { EGDSLayoutFlex, EGDSLayoutFlexItem } from "@egds/react-core/layout-flex";
import { EGDSText as EGDSText3 } from "@egds/react-core/text";
import { gql as gql11 } from "@shared-ui/apollo-client-wrapper";
var fragment8 = gql11`
  fragment EGDSGraphicTextFragment on EGDSGraphicText {
    graphic {
      ...EGDSGraphicFragment
    }
    text
  }

  ${EGDSGraphic.fragment}
`;
var EGDSGraphicText = ({
  data,
  textSize,
  textWeight,
  textTheme,
  direction
}) => {
  const {
    graphic,
    text
  } = data;
  return /* @__PURE__ */React17.createElement(EGDSLayoutFlex, {
    direction
  }, /* @__PURE__ */React17.createElement(EGDSLayoutFlexItem, null, /* @__PURE__ */React17.createElement(EGDSText3, {
    size: textSize,
    theme: textTheme,
    weight: textWeight
  }, text)), /* @__PURE__ */React17.createElement(EGDSLayoutFlexItem, null, data.graphic && /* @__PURE__ */React17.createElement(EGDSGraphic, {
    data: data.graphic
  })));
};
EGDSGraphicText.fragment = fragment8;
EGDSGraphicText.displayName = "EGDSGraphicText";

// src/help-center-search.tsx
import { ViewMedium as ViewMedium3, Viewport as Viewport4, ViewSmall as ViewSmall4 } from "@shared-ui/viewport-context";

// src/generic-search/generic-article-search.tsx
import React18, { useEffect } from "react";
import { ArticleContentDialog, useArticle as useArticle2 } from "@shared-ui/retail-help-center-help-articles";
var GenericArticleSearch = ({
  searchTerm,
  onClose,
  triggerRef
}) => {
  const {
    setArticleIdentifier,
    setTriggerRef
  } = useArticle2();
  useEffect(() => {
    if (triggerRef) {
      setTriggerRef(triggerRef);
    }
  }, [triggerRef]);
  useEffect(() => {
    if (!searchTerm) {
      return;
    }
    setArticleIdentifier({
      articleIdentifier: {
        searchTerm
      }
    });
  }, [searchTerm]);
  return /* @__PURE__ */React18.createElement(ArticleContentDialog, {
    onClose
  });
};

// src/intelligent-search/query/intelligent-search.tsx
import React42 from "react";
import { EGDSLayoutGrid as EGDSLayoutGrid10, EGDSLayoutGridItem as EGDSLayoutGridItem10, MinMax as MinMax4, Repeat as Repeat4 } from "@egds/react-core/layout-grid";
import { EGDSLayoutPosition as EGDSLayoutPosition3 } from "@egds/react-core/layout-position";
import { EGDSLoader } from "@egds/react-core/loader";
import { gql as gql38, useQuery } from "@shared-ui/apollo-client-wrapper";
import { useBexApi } from "@shared-ui/bex-api-context";

// src/intelligent-search/ai-summary/ai-summary.tsx
import React25 from "react";
import { EGDSCard } from "@egds/react-core/cards";
import { EGDSLayoutGrid, EGDSLayoutGridItem, MinMax, Repeat } from "@egds/react-core/layout-grid";
import { EGDSSpacing as EGDSSpacing2 } from "@egds/react-core/spacing";
import { gql as gql18 } from "@shared-ui/apollo-client-wrapper";

// ../internal/src/components/egds-list/egds-bulleted-list.tsx
import React21 from "react";
import { EGDSList } from "@egds/react-core/list";
import { gql as gql14 } from "@shared-ui/apollo-client-wrapper";

// ../internal/src/components/egds-list/egds-text-list-item.tsx
import React20 from "react";
import { gql as gql13 } from "@shared-ui/apollo-client-wrapper";

// ../internal/src/components/egds-list/egds-text-standard-list-item.tsx
import React19 from "react";
import { EGDSListItem } from "@egds/react-core/list";
import { gql as gql12 } from "@shared-ui/apollo-client-wrapper";
var fragment9 = gql12`
  fragment EGDSTextStandardListItemFragment on EGDSTextStandardListItem {
    text
  }
`;
var EGDSTextStandardListItem = ({
  data
}) => {
  const {
    text
  } = data;
  return /* @__PURE__ */React19.createElement(EGDSListItem, null, text);
};
EGDSTextStandardListItem.fragment = fragment9;
EGDSTextStandardListItem.displayName = "EGDSTextStandardListItem";

// ../internal/src/components/egds-list/egds-text-list-item.tsx
var fragment10 = gql13`
  fragment EGDSTextListItemFragment on EGDSTextListItem {
    ...EGDSTextStandardListItemFragment
  }

  ${EGDSTextStandardListItem.fragment}
`;
var EGDSTextListItem = ({
  data
}) => {
  switch (data.__typename) {
    case "EGDSTextStandardListItem":
      return /* @__PURE__ */React20.createElement(EGDSTextStandardListItem, {
        data
      });
    default:
      return null;
  }
};
EGDSTextListItem.fragment = fragment10;
EGDSTextListItem.displayName = "EGDSTextListItem";

// ../internal/src/components/egds-list/egds-bulleted-list.tsx
var fragment11 = gql14`
  fragment EGDSBulletedListFragment on EGDSBulletedList {
    listItems {
      ...EGDSTextListItemFragment
    }
  }

  ${EGDSTextListItem.fragment}
`;
var EGDSBulletedList = ({
  data
}) => {
  var _a;
  if (((_a = data == null ? void 0 : data.listItems) == null ? void 0 : _a.length) === 0) {
    return null;
  }
  return /* @__PURE__ */React21.createElement(EGDSList, null, data.listItems.map((item, key) => /* @__PURE__ */React21.createElement(EGDSTextListItem, {
    data: item,
    key
  })));
};
EGDSBulletedList.displayName = "EGDSBulletedList";
EGDSBulletedList.fragment = fragment11;

// ../internal/src/components/egds-list/egds-ordered-list.tsx
import React22 from "react";
import { EGDSList as EGDSList2, EGDSListItem as EGDSListItem2 } from "@egds/react-core/list";
import { gql as gql15 } from "@shared-ui/apollo-client-wrapper";
var fragment12 = gql15`
  fragment EGDSOrderedListFragment on EGDSOrderedList {
    items {
      ...EGDSSpannableTextFragment
    }
  }
  ${EGDSSpannableText.fragment}
`;
var EGDSOrderedList = props => {
  const _a = props,
    {
      data: {
        items
      },
      onLinkClickHandler
    } = _a,
    listProps = __objRest(_a, ["data", "onLinkClickHandler"]);
  if (!items.length) {
    return null;
  }
  return /* @__PURE__ */React22.createElement(EGDSList2, __spreadValues({}, listProps), items.map((item, index) => {
    return /* @__PURE__ */React22.createElement(EGDSListItem2, {
      key: index
    }, item.__typename === "EGDSSpannableText" && /* @__PURE__ */React22.createElement(EGDSSpannableText, __spreadValues({
      data: item
    }, {
      onLinkClickHandler
    })));
  }));
};
EGDSOrderedList.fragment = fragment12;
EGDSOrderedList.displayName = "EGDSOrderedList";

// ../internal/src/components/egds-list/egds-unordered-list.tsx
import React23 from "react";
import { EGDSList as EGDSList3, EGDSListItem as EGDSListItem3 } from "@egds/react-core/list";
import { gql as gql16 } from "@shared-ui/apollo-client-wrapper";
var fragment13 = gql16`
  fragment EGDSUnorderedListFragment on EGDSUnorderedList {
    items {
      ...EGDSSpannableTextFragment
    }
    listItems {
      ...EGDSTextListItemFragment
    }
  }
  ${EGDSSpannableText.fragment}
  ${EGDSTextListItem.fragment}
`;
var EGDSUnorderedList = props => {
  const _a = props,
    {
      data: {
        items,
        listItems
      },
      onLinkClickHandler
    } = _a,
    listProps = __objRest(_a, ["data", "onLinkClickHandler"]);
  if (!listItems.length && !items.length) {
    return null;
  }
  return /* @__PURE__ */React23.createElement(EGDSList3, __spreadValues({}, listProps), items.length > 0 && items.map((item, index) => {
    return /* @__PURE__ */React23.createElement(EGDSListItem3, {
      key: index
    }, item.__typename === "EGDSSpannableText" && /* @__PURE__ */React23.createElement(EGDSSpannableText, __spreadValues({
      data: item
    }, {
      onLinkClickHandler
    })));
  }), listItems.length > 0 && listItems.map((item, index) => {
    return /* @__PURE__ */React23.createElement(EGDSTextListItem, __spreadValues({
      key: index,
      data: item
    }, {
      onLinkClickHandler
    }));
  }));
};
EGDSUnorderedList.fragment = fragment13;
EGDSUnorderedList.displayName = "EGDSUnorderedList";

// src/intelligent-search/ai-summary/summarization-disclaimer.tsx
import React24 from "react";
import { EGDSIconSize as EGDSIconSize2 } from "@egds/react-core/icons";
import { EGDSLayoutFlex as EGDSLayoutFlex2, EGDSLayoutFlexItem as EGDSLayoutFlexItem2 } from "@egds/react-core/layout-flex";
import { EGDSLayoutPosition } from "@egds/react-core/layout-position";
import { EGDSText as EGDSText4 } from "@egds/react-core/text";
import { gql as gql17 } from "@shared-ui/apollo-client-wrapper";
var fragment14 = gql17`
  fragment ISSummarizationDisclaimerFragment on ISSummarizationDisclaimer {
    text
    icon {
      ...EGDSIconFragment
    }
  }
`;
var SummarizationDisclaimer = ({
  data,
  textSize
}) => {
  return /* @__PURE__ */React24.createElement(EGDSLayoutFlex2, {
    wrap: "wrap",
    space: "two",
    direction: "row"
  }, /* @__PURE__ */React24.createElement(EGDSLayoutFlexItem2, null, /* @__PURE__ */React24.createElement(HelpCenterEGDSIcon, {
    data: data == null ? void 0 : data.icon,
    size: EGDSIconSize2.EXTRA_SMALL
  })), /* @__PURE__ */React24.createElement(EGDSLayoutFlexItem2, null, /* @__PURE__ */React24.createElement(EGDSLayoutPosition, {
    type: "relative"
  }, /* @__PURE__ */React24.createElement(EGDSLayoutPosition, {
    type: "relative",
    position: {
      top: "center",
      left: "center"
    },
    cloneElement: true
  }, /* @__PURE__ */React24.createElement(EGDSText4, {
    size: textSize
  }, data == null ? void 0 : data.text)))));
};
SummarizationDisclaimer.fragment = fragment14;
SummarizationDisclaimer.displayName = "SummarizationDisclaimer";

// src/intelligent-search/ai-summary/ai-summary.tsx
var fragment15 = gql18`
  fragment ISAISummaryFragment on ISAISummary {
    summary {
      ...EGDSUnorderedListFragment
    }
    summarizationDisclaimer {
      ...ISSummarizationDisclaimerFragment
    }
  }
  ${EGDSUnorderedList.fragment}
  ${SummarizationDisclaimer.fragment}
`;
var AISummaryFragment = ({
  data
}) => {
  if (!data) {
    return null;
  }
  const {
    summary,
    summarizationDisclaimer
  } = data;
  return /* @__PURE__ */React25.createElement(EGDSSpacing2, {
    margin: {
      blockstart: "twelve"
    }
  }, /* @__PURE__ */React25.createElement(EGDSLayoutGrid, {
    columns: [Repeat("auto-fit", MinMax("120x", "0.5fr"))]
  }, /* @__PURE__ */React25.createElement(EGDSCard, {
    padded: true,
    backgroundTheme: "secondary"
  }, /* @__PURE__ */React25.createElement(EGDSLayoutGrid, {
    space: "large"
  }, /* @__PURE__ */React25.createElement(EGDSLayoutGridItem, null, /* @__PURE__ */React25.createElement(EGDSUnorderedList, {
    data: summary
  })), summarizationDisclaimer && /* @__PURE__ */React25.createElement(EGDSLayoutGridItem, null, /* @__PURE__ */React25.createElement(SummarizationDisclaimer, {
    data: summarizationDisclaimer,
    textSize: 100
  }))))));
};
AISummaryFragment.fragment = fragment15;
AISummaryFragment.displayName = "AISummaryFragment";

// src/intelligent-search/booking-view/booking-selection.tsx
import React31 from "react";
import { EGDSLayoutGrid as EGDSLayoutGrid3, EGDSLayoutGridItem as EGDSLayoutGridItem3, MinMax as MinMax2, Repeat as Repeat2 } from "@egds/react-core/layout-grid";
import { gql as gql26 } from "@shared-ui/apollo-client-wrapper";

// src/intelligent-search/booking-view/booking-card.tsx
import React30 from "react";
import { EGDSButtonSize as EGDSButtonSize4 } from "@egds/react-core/button";
import { EGDSCard as EGDSCard2, EGDSCardContentSection, EGDSCardLink } from "@egds/react-core/cards";
import { EGDSIconSize as EGDSIconSize3 } from "@egds/react-core/icons";
import { EGDSLayoutFlex as EGDSLayoutFlex3, EGDSLayoutFlexItem as EGDSLayoutFlexItem3 } from "@egds/react-core/layout-flex";
import { EGDSLayoutGrid as EGDSLayoutGrid2, EGDSLayoutGridItem as EGDSLayoutGridItem2 } from "@egds/react-core/layout-grid";
import { EGDSLayoutPosition as EGDSLayoutPosition2 } from "@egds/react-core/layout-position";
import { EGDSSpacing as EGDSSpacing3 } from "@egds/react-core/spacing";
import { EGDSHeading as EGDSHeading2, EGDSText as EGDSText5 } from "@egds/react-core/text";
import { gql as gql25 } from "@shared-ui/apollo-client-wrapper";

// ../internal/src/components/egds-badge/egds-standard-badge.tsx
import React26 from "react";
import { EGDSBadgeStandard } from "@egds/react-core/badge";
import { gql as gql19 } from "@shared-ui/apollo-client-wrapper";

// ../internal/src/components/egds-badge/egds-badge-themes-map.ts
var standardBadgeThemesMap = {
  standard: "standard",
  emphasis: "emphasis",
  info: "info",
  featured: "featured",
  brand: "brand",
  warning: "warning",
  positive: "positive"
};

// ../internal/src/components/egds-badge/egds-standard-badge.tsx
var EGDSStandardBadgeFragment__ = gql19`
  fragment EGDSStandardBadgeFragment on EGDSStandardBadge {
    __typename
    text
    theme
    graphic {
      ...EGDSGraphicFragment
    }
  }
  ${EGDSGraphic.fragment}
`;
var HelpCenterEGDSBadge = ({
  data
}) => {
  var _a;
  if (!data.text) {
    return null;
  }
  return /* @__PURE__ */React26.createElement(EGDSBadgeStandard, {
    text: data.text,
    theme: standardBadgeThemesMap[(_a = data.theme) != null ? _a : "standard"]
  }, data.graphic && /* @__PURE__ */React26.createElement(EGDSGraphic, {
    data: data.graphic
  }));
};
HelpCenterEGDSBadge.displayName = "HelpCenterEGDSBadge";
HelpCenterEGDSBadge.fragment = EGDSStandardBadgeFragment__;

// src/intelligent-search/follow-up-action/actions/follow-up-action.tsx
import React29 from "react";
import { EGDSButtonSize as EGDSButtonSize3 } from "@egds/react-core/button";
import { gql as gql23 } from "@shared-ui/apollo-client-wrapper";

// src/intelligent-search/follow-up-action/actions/link-button.tsx
import React27 from "react";
import { EGDSButtonSize } from "@egds/react-core/button";
import { gql as gql21 } from "@shared-ui/apollo-client-wrapper";
import { useEgClickstream as useEgClickstream2 } from "@shared-ui/clickstream-analytics-context";

// src/intelligent-search/follow-up-action/actions/clickstream.tsx
import { gql as gql20 } from "@shared-ui/apollo-client-wrapper";
var FollowUpActionclickStreamFragment = gql20`
  fragment FollowUpActionclickStreamFragment on ISFollowUpActionsClickStreamAnalytics {
    event {
      actionLocation
      actionReason
      eventCategory
      eventName
      eventType
      eventVersion
      __typename
    }
    experience {
      appName
      appVersion
      pageName
      pageNameDetailed
      __typename
    }
    workFlowList {
      automationStatus
      automationStatusReason
      channel
      intent
      orderLineId
      productLine
      subIntent
      __typename
    }
    __typename
  }
`;

// src/intelligent-search/follow-up-action/actions/helper.ts
var buildClickStreamForFollowUpActions = followUpActionsClickStreamAnalytics => {
  return {
    event: __spreadValues(__spreadValues({
      event_name: followUpActionsClickStreamAnalytics.event.eventName,
      event_version: followUpActionsClickStreamAnalytics.event.eventVersion,
      event_type: followUpActionsClickStreamAnalytics.event.eventType,
      event_category: followUpActionsClickStreamAnalytics.event.eventCategory
    }, followUpActionsClickStreamAnalytics.event.actionLocation && {
      action_location: followUpActionsClickStreamAnalytics.event.actionLocation
    }), followUpActionsClickStreamAnalytics.event.actionReason && {
      action_reason: followUpActionsClickStreamAnalytics.event.actionReason
    }),
    experience: {
      page_name: followUpActionsClickStreamAnalytics.experience.pageName,
      app_name: followUpActionsClickStreamAnalytics.experience.appName,
      app_version: followUpActionsClickStreamAnalytics.experience.appVersion,
      page_name_detailed: followUpActionsClickStreamAnalytics.experience.pageNameDetailed
    }
  };
};

// src/intelligent-search/follow-up-action/actions/link-button.tsx
var fragment16 = gql21`
  fragment ISLinkButtonFragment on ISLinkButton {
    button {
      ...EGDSButtonFragment
    }
    clickStream {
      ...FollowUpActionclickStreamFragment
    }
    url {
      ... on UILinkAction {
        resource {
          value
        }
        target
      }
    }
    __typename
  }
  ${HelpCenterEGDSButton.fragment}
  ${FollowUpActionclickStreamFragment}
`;
var LinkButton = ({
  data,
  iconPosition = "LEADING" /* LEADING */,
  size = EGDSButtonSize.LARGE,
  isFullWidth = true
}) => {
  const trackClick = useEgClickstream2();
  const followUpActions = data.clickStream;
  return /* @__PURE__ */React27.createElement(HelpCenterEGDSButton, {
    data: data == null ? void 0 : data.button,
    onClickHandler: () => {
      var _a, _b, _c;
      if (((_a = data == null ? void 0 : data.url) == null ? void 0 : _a.__typename) === "UILinkAction") {
        if (followUpActions) {
          trackClick(buildClickStreamForFollowUpActions(followUpActions));
        }
        window.open((_b = data == null ? void 0 : data.url) == null ? void 0 : _b.resource.value, ((_c = data == null ? void 0 : data.url) == null ? void 0 : _c.target) === "EXTERNAL" /* EXTERNAL */ ? "_blank" : "_self");
      }
    },
    iconPosition,
    size,
    content: "Label",
    isFullWidth
  });
};
LinkButton.fragment = fragment16;
LinkButton.displayName = "LinkButtons";

// src/intelligent-search/follow-up-action/actions/va-button.tsx
import React28 from "react";
import { EGDSButtonSize as EGDSButtonSize2 } from "@egds/react-core/button";
import { gql as gql22 } from "@shared-ui/apollo-client-wrapper";
import { useEgClickstream as useEgClickstream3 } from "@shared-ui/clickstream-analytics-context";
import { useVirtualAgentContext } from "@shared-ui/retail-help-center-util";
var fragment17 = gql22`
  fragment ISVAButtonFragment on ISVAButton {
    button {
      ...EGDSButtonFragment
    }
    clickStream {
      ...FollowUpActionclickStreamFragment
    }
    intent
    messageType
    text
    payload
    __typename
  }
  ${FollowUpActionclickStreamFragment}
`;
var VaButton = ({
  data,
  iconPosition = "LEADING" /* LEADING */,
  size = EGDSButtonSize2.LARGE,
  isFullWidth = true
}) => {
  const {
    controller
  } = useVirtualAgentContext();
  const trackClick = useEgClickstream3();
  const followUpActions = data.clickStream;
  return /* @__PURE__ */React28.createElement(HelpCenterEGDSButton, {
    onClickHandler: async () => {
      const message = {
        text: data == null ? void 0 : data.text,
        messageType: data == null ? void 0 : data.messageType,
        intent: data == null ? void 0 : data.intent
      };
      if (data == null ? void 0 : data.payload) {
        message.payload = data == null ? void 0 : data.payload;
        controller.sendMessage(message);
      }
      if (followUpActions) {
        trackClick(buildClickStreamForFollowUpActions(followUpActions));
      }
    },
    data: data == null ? void 0 : data.button,
    iconPosition,
    size,
    content: "Label",
    isFullWidth
  });
};
VaButton.fragment = fragment17;
VaButton.displayName = "VaButtons";

// src/intelligent-search/follow-up-action/actions/follow-up-action.tsx
var fragment18 = gql23`
  fragment FollowUpActionFragment on ISFollowUpAction {
    __typename
    ...ISLinkButtonFragment
    ...ISVAButtonFragment
  }
  ${VaButton.fragment}
  ${LinkButton.fragment}
`;
var FollowUpAction = ({
  data,
  iconPosition = "LEADING" /* LEADING */,
  size = EGDSButtonSize3.LARGE,
  isFullWidth = true
}) => {
  switch (data == null ? void 0 : data.__typename) {
    case "ISVAButton":
      return /* @__PURE__ */React29.createElement(VaButton, {
        data,
        isFullWidth,
        size,
        iconPosition
      });
    case "ISLinkButton":
      return /* @__PURE__ */React29.createElement(LinkButton, {
        data,
        isFullWidth,
        size,
        iconPosition
      });
    default:
      return null;
  }
};
FollowUpAction.fragment = fragment18;
FollowUpAction.displayName = "FollowUpActionButton";

// src/intelligent-search/booking-view/request-payload.tsx
import { gql as gql24 } from "@shared-ui/apollo-client-wrapper";
var ISRequestPayloadFragment = gql24`
  fragment ISRequestPayloadFragment on ISRequestPayload {
    searchTerm
    orderItemUuid
    viewType
    servicePayload
  }
`;

// src/intelligent-search/booking-view/booking-card.tsx
var fragment19 = gql25`
  fragment ISBookingCardFragment on ISBookingCard {
    __typename
    bookingCardActions: actions {
      ...FollowUpActionFragment
    }
    badges {
      __typename
      ...EGDSStandardBadgeFragment
    }
    bookingDetails
    intelligentSearchRequestPayload {
      ...ISRequestPayloadFragment
    }
    title
    icon {
      ...EGDSIconFragment
    }
  }
  ${EGDSStandardBadgeFragment__}
  ${ISRequestPayloadFragment}
  ${FollowUpAction.fragment}
  ${HelpCenterEGDSIcon.fragment}
`;
var BookingCard = ({
  data,
  onClick
}) => {
  var _a, _b, _c, _d, _e;
  return /* @__PURE__ */React30.createElement(EGDSLayoutFlex3, {
    direction: "column",
    space: "two"
  }, /* @__PURE__ */React30.createElement(EGDSLayoutFlexItem3, null, /* @__PURE__ */React30.createElement(EGDSSpacing3, {
    margin: {
      blockend: "four"
    }
  }, /* @__PURE__ */React30.createElement(EGDSCard2, {
    padded: true,
    border: true
  }, /* @__PURE__ */React30.createElement(EGDSSpacing3, {
    margin: {
      blockend: "four"
    }
  }, /* @__PURE__ */React30.createElement(EGDSCard2, null, /* @__PURE__ */React30.createElement(EGDSLayoutGrid2, {
    columns: 4,
    space: "three"
  }, /* @__PURE__ */React30.createElement(EGDSLayoutGridItem2, {
    colSpan: 1
  }, /* @__PURE__ */React30.createElement(EGDSLayoutPosition2, {
    type: "relative"
  }, /* @__PURE__ */React30.createElement(EGDSLayoutPosition2, {
    type: "absolute",
    position: {
      top: "center",
      left: "center"
    },
    cloneElement: true
  }, /* @__PURE__ */React30.createElement(EGDSLayoutGrid2, null, /* @__PURE__ */React30.createElement(EGDSLayoutGridItem2, null, /* @__PURE__ */React30.createElement(HelpCenterEGDSIcon, {
    data: data == null ? void 0 : data.icon,
    size: EGDSIconSize3.XLARGE
  })))))), /* @__PURE__ */React30.createElement(EGDSLayoutGridItem2, {
    colSpan: 3
  }, /* @__PURE__ */React30.createElement(EGDSSpacing3, {
    margin: "one"
  }, /* @__PURE__ */React30.createElement(EGDSCardContentSection, {
    padded: false
  }, onClick && /* @__PURE__ */React30.createElement(EGDSCardLink, null, /* @__PURE__ */React30.createElement("button", {
    type: "button",
    onClick
  })), /* @__PURE__ */React30.createElement(EGDSLayoutFlex3, {
    space: "one",
    direction: "column"
  }, /* @__PURE__ */React30.createElement(EGDSLayoutFlexItem3, null, /* @__PURE__ */React30.createElement(EGDSLayoutFlex3, {
    space: "one",
    direction: "row"
  }, (_a = data == null ? void 0 : data.badges) == null ? void 0 : _a.map((ele, index) => {
    return /* @__PURE__ */React30.createElement(EGDSLayoutFlexItem3, {
      key: index
    }, /* @__PURE__ */React30.createElement(HelpCenterEGDSBadge, {
      data: ele
    }));
  }))), /* @__PURE__ */React30.createElement(EGDSLayoutFlexItem3, null, /* @__PURE__ */React30.createElement(EGDSHeading2, {
    size: 6,
    tag: "h6"
  }, data == null ? void 0 : data.title)), (_b = data == null ? void 0 : data.bookingDetails) == null ? void 0 : _b.map((ele, index) => {
    return /* @__PURE__ */React30.createElement(EGDSLayoutFlexItem3, {
      key: index
    }, /* @__PURE__ */React30.createElement(EGDSText5, {
      key: index,
      size: 300
    }, ele));
  })))))))), ((_c = data == null ? void 0 : data.bookingCardActions) == null ? void 0 : _c.length) && ((_d = data == null ? void 0 : data.bookingCardActions) == null ? void 0 : _d.length) > 0 && /* @__PURE__ */React30.createElement(FollowUpAction, {
    data: data.bookingCardActions[0],
    size: EGDSButtonSize4.MEDIUM
  })))), (_e = data == null ? void 0 : data.bookingCardActions) == null ? void 0 : _e.map((ele, index) => {
    if (index !== 0) {
      return /* @__PURE__ */React30.createElement(EGDSLayoutFlexItem3, {
        key: index
      }, /* @__PURE__ */React30.createElement(FollowUpAction, {
        data: ele,
        size: EGDSButtonSize4.SMALL
      }));
    }
    return null;
  }));
};
BookingCard.fragment = fragment19;
BookingCard.displayName = "BookingCard";

// src/intelligent-search/booking-view/booking-selection.tsx
var fragment20 = gql26`
  fragment ISBookingSelectionViewFragment on ISBookingSelectionView {
    bookings {
      ...ISBookingCardFragment
    }
    skipSelectionButton {
      ...EGDSButtonFragment
    }
    __typename
  }
  ${BookingCard.fragment}
  ${HelpCenterEGDSButton.fragment}
`;
var BookingSelection = ({
  data,
  onClick,
  searchTerm
}) => {
  var _a;
  if (!data) {
    return null;
  }
  const {
    bookings,
    skipSelectionButton
  } = data;
  const viewPointSize = [Repeat2("auto-fit", MinMax2("120x", "0.33fr"))];
  return /* @__PURE__ */React31.createElement("div", null, /* @__PURE__ */React31.createElement(EGDSLayoutGrid3, {
    space: "two",
    columns: {
      small: 1,
      medium: viewPointSize,
      large: viewPointSize
    }
  }, bookings == null ? void 0 : bookings.map((ele, index) => {
    return /* @__PURE__ */React31.createElement(EGDSLayoutGridItem3, {
      key: index
    }, /* @__PURE__ */React31.createElement(BookingCard, {
      data: ele,
      onClick: () => {
        if (ele.intelligentSearchRequestPayload) {
          onClick(ele.intelligentSearchRequestPayload);
        }
      }
    }));
  })), /* @__PURE__ */React31.createElement(EGDSLayoutGrid3, {
    space: "two",
    columns: {
      small: 1,
      medium: viewPointSize,
      large: viewPointSize
    }
  }, skipSelectionButton && /* @__PURE__ */React31.createElement(EGDSLayoutGridItem3, null, /* @__PURE__ */React31.createElement(HelpCenterEGDSButton, {
    data: skipSelectionButton,
    isFullWidth: true,
    "data-stid": "skipButton",
    onClickHandler: () => {
      var _a2, _b;
      return onClick({
        viewType: "BOOKING_SKIP" /* BOOKING_SKIP */,
        searchTerm,
        servicePayload: (_b = (_a2 = bookings == null ? void 0 : bookings[0]) == null ? void 0 : _a2.intelligentSearchRequestPayload) == null ? void 0 : _b.servicePayload
      });
    }
  }, (_a = data == null ? void 0 : data.skipSelectionButton) == null ? void 0 : _a.primary))));
};
BookingSelection.fragment = fragment20;
BookingSelection.displayName = "BookingSelection";

// src/intelligent-search/feedback-view/feedback-view.tsx
import React32, { useState as useState2 } from "react";
import { EGDSTertiaryButton as EGDSTertiaryButton2 } from "@egds/react-core/button";
import { EGDSLayoutFlex as EGDSLayoutFlex4, EGDSLayoutFlexItem as EGDSLayoutFlexItem4 } from "@egds/react-core/layout-flex";
import { EGDSSpacing as EGDSSpacing4 } from "@egds/react-core/spacing";
import { EGDSText as EGDSText6 } from "@egds/react-core/text";
import { gql as gql28 } from "@shared-ui/apollo-client-wrapper";
import { useEgClickstream as useEgClickstream4 } from "@shared-ui/clickstream-analytics-context";

// src/intelligent-search/analytics/helper.ts
var buildClickStreamForFeedbackComponent = (feedbackClickstreamPayload, feedbackRating) => {
  return {
    event: __spreadProps(__spreadValues({
      event_name: feedbackClickstreamPayload.event.eventName,
      event_version: feedbackClickstreamPayload.event.eventVersion,
      event_type: feedbackClickstreamPayload.event.eventType
    }, feedbackClickstreamPayload.event.actionLocation && {
      action_location: feedbackClickstreamPayload.event.actionLocation
    }), {
      event_category: feedbackClickstreamPayload.event.eventCategory
    }),
    experience: {
      app_name: feedbackClickstreamPayload.experience.appName,
      app_version: feedbackClickstreamPayload.experience.appVersion,
      page_name: feedbackClickstreamPayload.experience.pageName,
      page_name_detailed: feedbackClickstreamPayload.experience.pageNameDetailed
    },
    article: {
      search_term: feedbackClickstreamPayload.article.searchTerm
    },
    feedback: {
      feedback_type: feedbackRating
    }
  };
};

// src/intelligent-search/analytics/clickstream.tsx
import { gql as gql27 } from "@shared-ui/apollo-client-wrapper";
var ArticlesSummarizationClickStreamAnalyticsFragment = gql27`
  fragment ArticlesSummarizationClickStreamAnalyticsFragment on ArticlesSummarizationClickStreamAnalytics {
    event {
      actionLocation
      eventCategory
      eventName
      eventType
      eventVersion
    }
    article {
      searchTerm
    }
    experience {
      appName
      appVersion
      pageName
      pageNameDetailed
    }
  }
`;

// src/intelligent-search/feedback-view/feedback-view.tsx
var fragment21 = gql28`
  fragment ISFeedbackFragment on ISFeedback {
    __typename
    feedbackLabel
    feedbackClickstreamPayload {
      ...ArticlesSummarizationClickStreamAnalyticsFragment
    }
    negativeFeedbackIcon {
      ...EGDSIconFragment
    }
    positiveFeedbackIcon {
      ...EGDSIconFragment
    }
    thankYouMessage {
      text
    }
  }
  ${HelpCenterEGDSIcon.fragment}
  ${ArticlesSummarizationClickStreamAnalyticsFragment}
`;
var FeedbackFragment = ({
  data
}) => {
  const [thankYouMessage, showThankYouMessage] = useState2(false);
  const [disabled, disableButton] = useState2(false);
  const trackClick = useEgClickstream4();
  const POSITIVE = "POSITIVE";
  const NEGATIVE = "NEGATIVE";
  const handleRatingClick = feedbackRating => {
    trackClick(buildClickStreamForFeedbackComponent(data.feedbackClickstreamPayload, feedbackRating));
    showThankYouMessage(true);
    disableButton(true);
  };
  return /* @__PURE__ */React32.createElement(EGDSSpacing4, {
    margin: {
      blockstart: "six"
    }
  }, /* @__PURE__ */React32.createElement("div", {
    "data-stid": "help-center-search-feedback"
  }, /* @__PURE__ */React32.createElement(EGDSLayoutFlex4, null, /* @__PURE__ */React32.createElement(EGDSLayoutFlexItem4, null, /* @__PURE__ */React32.createElement(EGDSText6, {
    theme: "standard",
    spacing: "two"
  }, data.feedbackLabel)), /* @__PURE__ */React32.createElement(EGDSLayoutFlexItem4, null, /* @__PURE__ */React32.createElement(EGDSTertiaryButton2, {
    "data-stid": "feedback-positive",
    disabled,
    onClick: () => handleRatingClick(POSITIVE)
  }, /* @__PURE__ */React32.createElement(HelpCenterEGDSIcon, {
    data: data.positiveFeedbackIcon
  }))), /* @__PURE__ */React32.createElement(EGDSLayoutFlexItem4, null, /* @__PURE__ */React32.createElement(EGDSTertiaryButton2, {
    "data-stid": "feedback-negative",
    disabled,
    onClick: () => handleRatingClick(NEGATIVE)
  }, /* @__PURE__ */React32.createElement(HelpCenterEGDSIcon, {
    data: data.negativeFeedbackIcon
  })))), thankYouMessage && /* @__PURE__ */React32.createElement(EGDSLayoutFlex4, null, /* @__PURE__ */React32.createElement(EGDSLayoutFlexItem4, null, /* @__PURE__ */React32.createElement(EGDSText6, null, data.thankYouMessage.text)))));
};
FeedbackFragment.fragment = fragment21;
FeedbackFragment.displayName = "FeedbackFragment";

// src/intelligent-search/follow-up-action/follow-up-action-view.tsx
import React33 from "react";
import { EGDSLayoutFlex as EGDSLayoutFlex5, EGDSLayoutFlexItem as EGDSLayoutFlexItem5 } from "@egds/react-core/layout-flex";
import { EGDSLayoutGrid as EGDSLayoutGrid4, EGDSLayoutGridItem as EGDSLayoutGridItem4 } from "@egds/react-core/layout-grid";
import { EGDSSpacing as EGDSSpacing5 } from "@egds/react-core/spacing";
import { gql as gql29 } from "@shared-ui/apollo-client-wrapper";
import { ViewLarge, ViewMedium, Viewport, ViewSmall } from "@shared-ui/viewport-context";
var fragment22 = gql29`
  fragment FollowUpViewFragment on ISFollowUpActions {
    actions {
      ...FollowUpActionFragment
    }
    __typename
  }
  ${FollowUpAction.fragment}
`;
var FollowUpActionView = ({
  data
}) => {
  var _a, _b, _c;
  return /* @__PURE__ */React33.createElement(Viewport, null, /* @__PURE__ */React33.createElement(ViewLarge, null, /* @__PURE__ */React33.createElement(EGDSSpacing5, {
    margin: {
      blockstart: "two",
      blockend: "two"
    }
  }, /* @__PURE__ */React33.createElement(EGDSLayoutGrid4, {
    columns: 2
  }, /* @__PURE__ */React33.createElement(EGDSLayoutGridItem4, null, /* @__PURE__ */React33.createElement(EGDSLayoutFlex5, {
    space: "two",
    wrap: "wrap"
  }, (_a = data == null ? void 0 : data.actions) == null ? void 0 : _a.map((ele, index) => {
    return /* @__PURE__ */React33.createElement(EGDSLayoutFlexItem5, {
      key: index
    }, /* @__PURE__ */React33.createElement(FollowUpAction, {
      data: ele
    }));
  })))))), /* @__PURE__ */React33.createElement(ViewMedium, null, /* @__PURE__ */React33.createElement(EGDSSpacing5, {
    margin: {
      blockstart: "two",
      blockend: "two"
    }
  }, /* @__PURE__ */React33.createElement(EGDSLayoutGrid4, {
    columns: 2
  }, /* @__PURE__ */React33.createElement(EGDSLayoutGridItem4, null, /* @__PURE__ */React33.createElement(EGDSLayoutFlex5, {
    space: "two",
    wrap: "wrap"
  }, (_b = data == null ? void 0 : data.actions) == null ? void 0 : _b.map((ele, index) => {
    return /* @__PURE__ */React33.createElement(EGDSLayoutFlexItem5, {
      key: index
    }, /* @__PURE__ */React33.createElement(FollowUpAction, {
      data: ele
    }));
  })))))), /* @__PURE__ */React33.createElement(ViewSmall, null, /* @__PURE__ */React33.createElement(EGDSSpacing5, {
    margin: {
      blockstart: "two",
      blockend: "two"
    }
  }, /* @__PURE__ */React33.createElement(EGDSLayoutFlex5, {
    space: "two",
    direction: "column"
  }, (_c = data == null ? void 0 : data.actions) == null ? void 0 : _c.map((ele, index) => {
    return /* @__PURE__ */React33.createElement(EGDSLayoutFlexItem5, {
      grow: 4,
      key: index
    }, /* @__PURE__ */React33.createElement(FollowUpAction, {
      data: ele
    }));
  })))));
};
FollowUpActionView.fragment = fragment22;
FollowUpActionView.displayName = "FollowUpActionView";

// src/intelligent-search/generic-view/generic-view.tsx
import React39 from "react";
import { EGDSLayoutGrid as EGDSLayoutGrid7, EGDSLayoutGridItem as EGDSLayoutGridItem7 } from "@egds/react-core/layout-grid";
import { EGDSSpacing as EGDSSpacing6 } from "@egds/react-core/spacing";
import { gql as gql35 } from "@shared-ui/apollo-client-wrapper";

// src/intelligent-search/generic-view/view-section/generic-view-section.tsx
import React38 from "react";
import { EGDSLayoutGrid as EGDSLayoutGrid6, EGDSLayoutGridItem as EGDSLayoutGridItem6 } from "@egds/react-core/layout-grid";
import { gql as gql34 } from "@shared-ui/apollo-client-wrapper";

// src/intelligent-search/generic-view/view-type/generic-view-type.tsx
import React37 from "react";
import { gql as gql33 } from "@shared-ui/apollo-client-wrapper";

// src/intelligent-search/generic-view/view-type/generic-action.tsx
import React34 from "react";
import { EGDSLayoutGrid as EGDSLayoutGrid5, EGDSLayoutGridItem as EGDSLayoutGridItem5, MinMax as MinMax3, Repeat as Repeat3 } from "@egds/react-core/layout-grid";
import { gql as gql30 } from "@shared-ui/apollo-client-wrapper";
import { ViewLarge as ViewLarge2, ViewMedium as ViewMedium2, Viewport as Viewport2, ViewSmall as ViewSmall2 } from "@shared-ui/viewport-context";
var fragment23 = gql30`
  fragment ISGenericActionFragment on ISGenericAction {
    actions {
      __typename
      ...FollowUpActionFragment
    }
  }
  ${FollowUpAction.fragment}
`;
var GenericActionFragment = ({
  data
}) => {
  var _a, _b, _c;
  return /* @__PURE__ */React34.createElement(Viewport2, null, /* @__PURE__ */React34.createElement(ViewLarge2, null, /* @__PURE__ */React34.createElement(EGDSLayoutGrid5, {
    columns: [Repeat3("auto-fit", MinMax3("120x", "0.33fr"))],
    autoRows: ["1fr"],
    space: "six"
  }, (_a = data == null ? void 0 : data.actions) == null ? void 0 : _a.map((ele, index) => /* @__PURE__ */React34.createElement(EGDSLayoutGridItem5, {
    key: `help-center-generic-view-action-${index}`
  }, /* @__PURE__ */React34.createElement(FollowUpAction, {
    data: ele,
    key: index
  }), ";")))), /* @__PURE__ */React34.createElement(ViewMedium2, null, /* @__PURE__ */React34.createElement(EGDSLayoutGrid5, {
    columns: [Repeat3("auto-fit", MinMax3("70x", "0.33fr"))],
    autoRows: ["1fr"],
    space: "six"
  }, (_b = data == null ? void 0 : data.actions) == null ? void 0 : _b.map((ele, index) => /* @__PURE__ */React34.createElement(EGDSLayoutGridItem5, {
    key: `help-center-generic-view-action-${index}`
  }, /* @__PURE__ */React34.createElement(FollowUpAction, {
    data: ele,
    key: index
  }), ";")))), /* @__PURE__ */React34.createElement(ViewSmall2, null, /* @__PURE__ */React34.createElement(EGDSLayoutGrid5, {
    columns: [Repeat3("auto-fit", MinMax3("70x", "1fr"))],
    autoRows: ["1fr"],
    space: "six"
  }, (_c = data == null ? void 0 : data.actions) == null ? void 0 : _c.map((ele, index) => /* @__PURE__ */React34.createElement(EGDSLayoutGridItem5, {
    key: `help-center-generic-view-action-${index}`
  }, /* @__PURE__ */React34.createElement(FollowUpAction, {
    data: ele,
    key: index
  }), ";")))));
};
GenericActionFragment.fragment = fragment23;
GenericActionFragment.displayName = "GenericActionFragment";

// src/intelligent-search/generic-view/view-type/generic-header.tsx
import React35 from "react";
import { gql as gql31 } from "@shared-ui/apollo-client-wrapper";
var fragment24 = gql31`
  fragment ISGenericHeaderFragment on ISGenericHeader {
    headers {
      __typename
      ...EGDSHeadingFragment
    }
    __typename
  }
  ${HelpCenterEGDSHeading.fragment}
`;
var GenericHeaderFragment = ({
  data
}) => {
  var _a;
  return /* @__PURE__ */React35.createElement("div", {
    "data-stid": "help-center-generic-view-header"
  }, (_a = data == null ? void 0 : data.headers) == null ? void 0 : _a.map((ele, index) => {
    return /* @__PURE__ */React35.createElement(HelpCenterEGDSHeading, {
      data: ele,
      size: 5,
      key: index
    });
  }));
};
GenericHeaderFragment.fragment = fragment24;
GenericHeaderFragment.displayName = "GenericHeaderFragment";

// src/intelligent-search/generic-view/view-type/generic-text.tsx
import React36 from "react";
import { EGDSParagraph as EGDSParagraph3 } from "@egds/react-core/text";
import { gql as gql32 } from "@shared-ui/apollo-client-wrapper";
var fragment25 = gql32`
  fragment ISGenericTextFragment on ISGenericText {
    texts
  }
`;
var GenericTextFragment = ({
  data
}) => {
  return /* @__PURE__ */React36.createElement(EGDSParagraph3, {
    size: 1
  }, data.texts);
};
GenericTextFragment.fragment = fragment25;
GenericTextFragment.displayName = "GenericTextFragment";

// src/intelligent-search/generic-view/view-type/generic-view-type.tsx
var fragment26 = gql33`
  fragment ISGenericViewTypeFragment on ISGenericViewType {
    ...ISGenericHeaderFragment
    ...ISGenericTextFragment
    ...ISGenericActionFragment
  }
  ${GenericHeaderFragment.fragment}
  ${GenericTextFragment.fragment}
  ${GenericActionFragment.fragment}
`;
var GenericViewTypeFragment = ({
  data
}) => {
  switch (data == null ? void 0 : data.__typename) {
    case "ISGenericAction":
      return /* @__PURE__ */React37.createElement(GenericActionFragment, {
        data
      });
    case "ISGenericHeader":
      return /* @__PURE__ */React37.createElement(GenericHeaderFragment, {
        data
      });
    case "ISGenericText":
      return /* @__PURE__ */React37.createElement(GenericTextFragment, {
        data
      });
    default:
      return null;
  }
};
GenericViewTypeFragment.fragment = fragment26;
GenericViewTypeFragment.displayName = "GenericViewTypeFragment";

// src/intelligent-search/generic-view/view-section/generic-view-section.tsx
var fragment27 = gql34`
  fragment ISGenericViewSectionFragment on ISGenericViewSection {
    sections {
      ...ISGenericViewTypeFragment
    }
  }
  ${GenericViewTypeFragment.fragment}
`;
var GenericViewSectionFragment = ({
  data
}) => {
  var _a;
  return /* @__PURE__ */React38.createElement(EGDSLayoutGrid6, {
    space: "three"
  }, (_a = data == null ? void 0 : data.sections) == null ? void 0 : _a.map((ele, index) => /* @__PURE__ */React38.createElement(EGDSLayoutGridItem6, {
    key: `help-center-generic-view-section-${index}`
  }, /* @__PURE__ */React38.createElement(GenericViewTypeFragment, {
    data: ele,
    key: index
  }), ";")));
};
GenericViewSectionFragment.fragment = fragment27;
GenericViewSectionFragment.displayName = "GenericViewSectionFragment";

// src/intelligent-search/generic-view/generic-view.tsx
var fragment28 = gql35`
  fragment ISGenericViewFragment on ISGenericView {
    __typename
    sections {
      ...ISGenericViewSectionFragment
    }
  }
  ${GenericViewSectionFragment.fragment}
`;
var GenericViewFragment = ({
  data
}) => {
  var _a;
  return /* @__PURE__ */React39.createElement(EGDSSpacing6, null, /* @__PURE__ */React39.createElement(EGDSLayoutGrid7, {
    space: "xlarge"
  }, (_a = data == null ? void 0 : data.sections) == null ? void 0 : _a.map((ele, index) => /* @__PURE__ */React39.createElement(EGDSLayoutGridItem7, {
    key: `help-center-generic-view-${index}`
  }, /* @__PURE__ */React39.createElement(GenericViewSectionFragment, {
    data: ele,
    key: index
  })))));
};
GenericViewFragment.fragment = fragment28;
GenericViewFragment.displayName = "GenericViewFragment";

// src/intelligent-search/technical-error-view/technical-error.tsx
import React40 from "react";
import { EGDSButtonSize as EGDSButtonSize5 } from "@egds/react-core/button";
import { EGDSIconSize as EGDSIconSize4 } from "@egds/react-core/icons";
import { EGDSLayoutGrid as EGDSLayoutGrid8, EGDSLayoutGridItem as EGDSLayoutGridItem8 } from "@egds/react-core/layout-grid";
import { EGDSSpacing as EGDSSpacing7 } from "@egds/react-core/spacing";
import { EGDSText as EGDSText7 } from "@egds/react-core/text";
import { gql as gql36 } from "@shared-ui/apollo-client-wrapper";
var fragment29 = gql36`
  fragment ISTechnicalErrorFragment on ISTechnicalErrorView {
    icon {
      ...EGDSIconFragment
    }
    header {
      ...EGDSHeadingFragment
    }
    body
    action {
      ...FollowUpActionFragment
    }
  }
  ${FollowUpAction.fragment}
  ${HelpCenterEGDSHeading.fragment}
  ${HelpCenterEGDSIcon.fragment}
`;
var TechnicalErrorView = ({
  data
}) => {
  if (!data) {
    return null;
  }
  const {
    icon,
    header,
    body,
    action
  } = data;
  return /* @__PURE__ */React40.createElement(EGDSSpacing7, {
    margin: {
      block: "twelve"
    }
  }, /* @__PURE__ */React40.createElement(EGDSLayoutGrid8, {
    justifyItems: "center",
    space: "three",
    columns: 3
  }, /* @__PURE__ */React40.createElement(EGDSLayoutGridItem8, {
    colStart: 2
  }, /* @__PURE__ */React40.createElement(EGDSLayoutGrid8, {
    justifyItems: "center",
    space: "three"
  }, /* @__PURE__ */React40.createElement(EGDSLayoutGridItem8, null, /* @__PURE__ */React40.createElement(HelpCenterEGDSIcon, {
    data: icon,
    size: EGDSIconSize4.LARGE
  })), header && /* @__PURE__ */React40.createElement(EGDSLayoutGridItem8, null, /* @__PURE__ */React40.createElement(HelpCenterEGDSHeading, {
    data: header,
    size: 5
  })), /* @__PURE__ */React40.createElement(EGDSLayoutGridItem8, null, /* @__PURE__ */React40.createElement(EGDSText7, {
    size: 200,
    align: "center"
  }, body)), action && /* @__PURE__ */React40.createElement(EGDSLayoutGridItem8, null, /* @__PURE__ */React40.createElement(FollowUpAction, {
    data: action,
    size: EGDSButtonSize5.LARGE
  }))))));
};
TechnicalErrorView.fragment = fragment29;
TechnicalErrorView.displayName = "TechnicalErrorFragment";

// src/intelligent-search/user-error-view/user-error.tsx
import React41 from "react";
import { EGDSLayoutGrid as EGDSLayoutGrid9, EGDSLayoutGridItem as EGDSLayoutGridItem9 } from "@egds/react-core/layout-grid";
import { gql as gql37 } from "@shared-ui/apollo-client-wrapper";
var fragment30 = gql37`
  fragment ISUserInputErrorFragment on ISUserInputErrorView {
    message {
      ...EGDSPlainTextFragment
      ...EGDSBulletedListFragment
    }
  }
  ${EGDSPlainText.fragment}
  ${EGDSBulletedList.fragment}
`;
var UserErrorView = ({
  data
}) => {
  if (!data) {
    return null;
  }
  const {
    message
  } = data;
  return /* @__PURE__ */React41.createElement(EGDSLayoutGrid9, {
    space: "one",
    justifyItems: "center"
  }, /* @__PURE__ */React41.createElement(EGDSLayoutGridItem9, null, /* @__PURE__ */React41.createElement(EGDSLayoutGrid9, null, message.map((item, index) => {
    switch (item.__typename) {
      case "EGDSPlainText":
        return /* @__PURE__ */React41.createElement(EGDSLayoutGridItem9, {
          key: index
        }, /* @__PURE__ */React41.createElement(EGDSPlainText, {
          data: item,
          size: 200
        }));
      case "EGDSBulletedList":
        return /* @__PURE__ */React41.createElement(EGDSLayoutGridItem9, {
          key: index
        }, /* @__PURE__ */React41.createElement(EGDSBulletedList, {
          data: item
        }));
      default:
        return null;
    }
  }))));
};
UserErrorView.fragment = fragment30;
UserErrorView.displayName = "UserInputErrorFragment";

// src/intelligent-search/query/intelligent-search.tsx
var __Query = gql38`
  query IntelligentSearch($context: ContextInput!, $requestPayload: ISRequestPayloadInput!) {
    searchHelpArticles(context: $context) {
      intelligentSearch {
        intelligentSearchByViewType(requestPayload: $requestPayload) {
          header {
            ...EGDSHeadingFragment
          }
          content {
            ...ISUserInputErrorFragment
            ...ISBookingSelectionViewFragment
            ...ISBookingCardFragment
            ...FollowUpViewFragment
            ...ISGenericViewFragment
            ...ISAISummaryFragment
            ...ISTechnicalErrorFragment
            ...ISFeedbackFragment
          }
        }
      }
    }
  }
  ${HelpCenterEGDSHeading.fragment}
  ${UserErrorView.fragment}
  ${FeedbackFragment.fragment}
  ${TechnicalErrorView.fragment}
  ${AISummaryFragment.fragment}
  ${GenericViewFragment.fragment}
  ${BookingSelection.fragment}
  ${BookingCard.fragment}
  ${FollowUpActionView.fragment}
`;
var IntelligentSearch = ({
  ssr = false,
  isPayload,
  onClick
}) => {
  var _a, _b;
  const {
    context
  } = useBexApi();
  const {
    searchTerm,
    orderItemUuid,
    viewType,
    servicePayload
  } = isPayload;
  const variables = {
    context,
    requestPayload: {
      searchTerm,
      orderItemUuid,
      viewType,
      servicePayload
    }
  };
  const {
    data,
    error,
    loading
  } = useQuery(__Query, {
    context: {
      shouldLogPerformance: true
    },
    variables,
    ssr
  });
  if (loading) {
    return /* @__PURE__ */React42.createElement(EGDSLayoutGrid10, {
      blockSize: "30vb"
    }, /* @__PURE__ */React42.createElement(EGDSLayoutPosition3, {
      type: "relative"
    }, /* @__PURE__ */React42.createElement(EGDSLayoutGridItem10, null, /* @__PURE__ */React42.createElement(EGDSLayoutPosition3, {
      type: "absolute",
      position: {
        top: "center",
        left: "center"
      },
      cloneElement: true
    }, /* @__PURE__ */React42.createElement(EGDSLoader, null)))));
  }
  if (error || !data) {
    return null;
  }
  return (_b = (_a = data == null ? void 0 : data.searchHelpArticles) == null ? void 0 : _a.intelligentSearch) == null ? void 0 : _b.intelligentSearchByViewType.map(ele => {
    const {
      header,
      content
    } = ele;
    const heading = header ? /* @__PURE__ */React42.createElement(HelpCenterEGDSHeading, {
      data: header,
      size: 5,
      padding: {
        blockend: "four"
      },
      margin: {
        blockstart: "six"
      }
    }) : null;
    const viewPointSize = [Repeat4("auto-fit", MinMax4("120x", "0.33fr"))];
    switch (content == null ? void 0 : content.__typename) {
      case "ISBookingSelectionView":
        return [heading, /* @__PURE__ */React42.createElement(BookingSelection, {
          data: content,
          onClick,
          searchTerm,
          key: "content"
        })];
      case "ISBookingCard":
        return [heading, /* @__PURE__ */React42.createElement(EGDSLayoutGrid10, {
          columns: {
            small: 1,
            medium: viewPointSize,
            large: viewPointSize
          },
          key: "content"
        }, /* @__PURE__ */React42.createElement(EGDSLayoutGridItem10, null, /* @__PURE__ */React42.createElement(BookingCard, {
          data: content
        })))];
      case "ISFollowUpActions":
        return [heading, /* @__PURE__ */React42.createElement(FollowUpActionView, {
          data: content,
          key: "content"
        })];
      case "ISGenericView":
        return [heading, /* @__PURE__ */React42.createElement(GenericViewFragment, {
          data: content,
          key: "content"
        })];
      case "ISAISummary":
        return /* @__PURE__ */React42.createElement(AISummaryFragment, {
          data: content
        });
      case "ISFeedback":
        return /* @__PURE__ */React42.createElement(FeedbackFragment, {
          data: content
        });
      case "ISUserInputErrorView":
        return [/* @__PURE__ */React42.createElement(EGDSLayoutGrid10, {
          justifyItems: "center",
          key: "header"
        }, /* @__PURE__ */React42.createElement(EGDSLayoutGridItem10, null, heading)), /* @__PURE__ */React42.createElement(UserErrorView, {
          data: content,
          key: "content"
        })];
      default:
        return /* @__PURE__ */React42.createElement(TechnicalErrorView, {
          data: content
        });
    }
  });
};
IntelligentSearch.displayName = "sharedui-IntelligentSearch";

// src/search-input/search-input.tsx
import React45, { useRef } from "react";
import { EGDSButtonSize as EGDSButtonSize6, EGDSPrimaryButton as EGDSPrimaryButton2 } from "@egds/react-core/button";
import { EGDSIcon as EGDSIcon2, EGDSIconSize as EGDSIconSize5 } from "@egds/react-core/icons";
import { EGDSLayoutFlex as EGDSLayoutFlex6, EGDSLayoutFlexItem as EGDSLayoutFlexItem6 } from "@egds/react-core/layout-flex";
import { EGDSLayoutGrid as EGDSLayoutGrid11, EGDSLayoutGridItem as EGDSLayoutGridItem11 } from "@egds/react-core/layout-grid";
import { gql as gql41, useQuery as useQuery2 } from "@shared-ui/apollo-client-wrapper";
import { useBexApi as useBexApi2 } from "@shared-ui/bex-api-context";
import { useEgClickstream as useEgClickstream5 } from "@shared-ui/clickstream-analytics-context";

// ../internal/src/components/egds-text-input/egds-text-input.tsx
import React43 from "react";
import { EGDSEmailInput, EGDSTextInput } from "@egds/react-core/input";
import { gql as gql39 } from "@shared-ui/apollo-client-wrapper";
var fragment31 = gql39`
  fragment EGDSTextInputFragment on EGDSInputField {
    label
    readOnly
    required
    leftIcon {
      ...EGDSIconFragment
    }
    rightIcon {
      ...EGDSIconFragment
    }
    validations {
      errorMessage
      ... on EGDSRegexInputValidation {
        pattern
      }
    }
  }
  ${HelpCenterEGDSIcon.fragment}
`;
var HelpCenterEGDSTextInput = _a => {
  var _b = _a,
    {
      data,
      value,
      onChange,
      invalid,
      pattern,
      disabled,
      onKeyPress
    } = _b,
    otherProps = __objRest(_b, ["data", "value", "onChange", "invalid", "pattern", "disabled", "onKeyPress"]);
  const {
    label,
    readOnly,
    required
  } = data;
  switch (data.__typename) {
    case "EGDSTextInputField":
      return /* @__PURE__ */React43.createElement(EGDSTextInput, __spreadProps(__spreadValues({}, otherProps), {
        label: label != null ? label : "",
        "aria-label": label != null ? label : "",
        readOnly: disabled || readOnly,
        required: required != null ? required : false,
        value,
        onChange,
        invalid,
        pattern,
        onKeyPress
      }));
    case "EGDSEmailInputField":
      return /* @__PURE__ */React43.createElement(EGDSEmailInput, __spreadProps(__spreadValues({}, otherProps), {
        label: label != null ? label : "",
        readOnly: disabled || readOnly,
        required: required != null ? required : false,
        value,
        onChange,
        invalid,
        pattern,
        onKeyPress
      }));
    default:
      return null;
  }
};
HelpCenterEGDSTextInput.fragment = fragment31;
HelpCenterEGDSTextInput.displayName = "HelpCenterEGDSTextInput";

// ../internal/src/components/egds-text-input/egds-text-area-input.tsx
import React44 from "react";
import { EGDSTextArea } from "@egds/react-core/input";
import { gql as gql40 } from "@shared-ui/apollo-client-wrapper";
var fragment32 = gql40`
  fragment EGDSTextAreaInputFragment on EGDSTextAreaInputField {
    label
    readOnly
    required
  }
`;
var EGDSTextAreaInput = ({
  data,
  value,
  minRows,
  maxRows,
  onChange,
  disabled
}) => {
  const {
    label,
    readOnly,
    required
  } = data;
  return /* @__PURE__ */React44.createElement(EGDSTextArea, {
    label,
    readOnly: disabled || readOnly,
    required: required != null ? required : false,
    value,
    minRows,
    maxRows,
    onChange
  });
};
EGDSTextAreaInput.fragment = fragment32;
EGDSTextAreaInput.displayName = "EGDSTextAreaInput";

// ../internal/src/utils/eg-clickstream-helper.ts
var buildClickstreamAnalyticsForSearchSubmittedEvent = (eventName, eventVersion, searchTerm) => {
  return {
    event: {
      event_name: eventName,
      event_version: eventVersion,
      event_type: EVENT_TYPE,
      event_category: EVENT_CATEGORY,
      action_location: HOME_PAGE
    },
    article: {
      search_term: searchTerm,
      article_group: ARTICLE_GROUP_FROM_SEARCH_BAR
    },
    experience: {
      page_name: PAGE_NAME,
      app_name: APP_NAME,
      app_version: APP_VERSION,
      page_name_detailed: PAGE_NAME_DETAILED
    }
  };
};

// src/search-input/search-input.tsx
import { ViewLarge as ViewLarge3, Viewport as Viewport3, ViewSmall as ViewSmall3 } from "@shared-ui/viewport-context";
var __HelpCenterSearchInputQuery = gql41`
  query HelpCenterSearchInput($context: ContextInput!) {
    searchHelpArticles(context: $context) {
      helpArticleSearchBar {
        searchBar {
          ...EGDSTextInputFragment
        }
        searchButton {
          ...EGDSButtonFragment
          icon {
            id
            description
            token
          }
        }
        intelligentSearchBackButton {
          ...EGDSButtonFragment
        }
        searchType
        waitMessage
        __typename
      }
      __typename
    }
  }
  ${HelpCenterEGDSTextInput.fragment}
  ${HelpCenterEGDSButton.fragment}
`;
var nonWhitespace = /\S/;
var SearchInput = ({
  onChange,
  onSubmit,
  ssr = false,
  value = "",
  onSearchTriggerRef
}) => {
  var _a, _b, _c, _d;
  const track = useEgClickstream5();
  const inputRef = useRef(null);
  const submitButtonRef = useRef(null);
  const {
    context
  } = useBexApi2();
  const {
    data,
    error,
    loading
  } = useQuery2(__HelpCenterSearchInputQuery, {
    context: {
      shouldLogPerformance: true
    },
    skip: false,
    variables: {
      context
    },
    ssr
  });
  if (loading || error || !data) {
    return null;
  }
  const submit = ref => {
    if (value && nonWhitespace.test(value)) {
      track(buildClickstreamAnalyticsForSearchSubmittedEvent(HELP_ARTICLE_SEARCH_SUBMITTED, HELP_ARTICLE_SEARCH_EVENT_VERSION, value));
      onSearchTriggerRef == null ? void 0 : onSearchTriggerRef(ref);
      onSubmit == null ? void 0 : onSubmit();
    }
  };
  const handleChange = newText => {
    var _a2, _b2;
    onChange == null ? void 0 : onChange({
      searchText: newText,
      searchType: data.searchHelpArticles.helpArticleSearchBar.searchType,
      intelligentSearchBackButton: (_a2 = data.searchHelpArticles.helpArticleSearchBar.intelligentSearchBackButton) != null ? _a2 : void 0,
      title: (_b2 = data.searchHelpArticles.helpArticleSearchBar.searchButton.primary) != null ? _b2 : void 0
    });
  };
  const onKeyPress = event => {
    if (event.key.toLowerCase() === "enter") {
      submit(inputRef);
    }
  };
  return /* @__PURE__ */React45.createElement(Viewport3, null, /* @__PURE__ */React45.createElement(ViewLarge3, null, /* @__PURE__ */React45.createElement(EGDSLayoutGrid11, {
    columns: {
      small: 1,
      medium: 5,
      large: 7
    },
    space: "six"
  }, /* @__PURE__ */React45.createElement(EGDSLayoutGridItem11, {
    colSpan: {
      small: 1,
      medium: 4,
      large: 6
    }
  }, /* @__PURE__ */React45.createElement("div", null, /* @__PURE__ */React45.createElement(HelpCenterEGDSTextInput, {
    domRef: inputRef,
    data: data.searchHelpArticles.helpArticleSearchBar.searchBar,
    onChange: event => handleChange(event.target.value),
    value,
    onKeyPress,
    "data-stid": "searchBar",
    icon: value === "" ? (_a = data.searchHelpArticles.helpArticleSearchBar.searchBar.leftIcon) == null ? void 0 : _a.id : void 0,
    hasClearButton: true
  }))), /* @__PURE__ */React45.createElement(EGDSLayoutGridItem11, {
    colSpan: {
      small: 1,
      medium: 1,
      large: 1
    }
  }, /* @__PURE__ */React45.createElement(HelpCenterEGDSButton, {
    domRef: submitButtonRef,
    data: __spreadProps(__spreadValues({}, data.searchHelpArticles.helpArticleSearchBar.searchButton), {
      icon: null
    }),
    "data-stid": "searchButton",
    onClickHandler: () => submit(submitButtonRef)
  })))), /* @__PURE__ */React45.createElement(ViewSmall3, null, /* @__PURE__ */React45.createElement(EGDSLayoutFlex6, {
    direction: "row",
    justifyContent: "space-between",
    space: "two"
  }, /* @__PURE__ */React45.createElement(EGDSLayoutFlexItem6, {
    grow: 5
  }, /* @__PURE__ */React45.createElement("div", null, /* @__PURE__ */React45.createElement(HelpCenterEGDSTextInput, {
    domRef: inputRef,
    data: data.searchHelpArticles.helpArticleSearchBar.searchBar,
    onChange: event => handleChange(event.target.value),
    value,
    onKeyPress,
    "data-stid": "searchBar",
    icon: value === "" ? (_b = data.searchHelpArticles.helpArticleSearchBar.searchBar.leftIcon) == null ? void 0 : _b.id : void 0,
    hasClearButton: true
  }))), /* @__PURE__ */React45.createElement(EGDSLayoutFlexItem6, null, /* @__PURE__ */React45.createElement(EGDSPrimaryButton2, {
    domRef: submitButtonRef,
    type: "button",
    size: EGDSButtonSize6.LARGE,
    "data-stid": "searchButton",
    onClick: () => submit(submitButtonRef)
  }, /* @__PURE__ */React45.createElement(EGDSIcon2, {
    name: ((_d = (_c = data.searchHelpArticles.helpArticleSearchBar.searchButton) == null ? void 0 : _c.icon) == null ? void 0 : _d.id) || "search",
    size: EGDSIconSize5.SMALL
  }))))));
};
SearchInput.displayName = "SearchInput";

// src/help-center-search.tsx
var HelpCenterSearch = ({
  ssr = false,
  onToggleISEngaged
}) => {
  var _a, _b;
  const [searchInput, setSearchInput] = useState5();
  const [isPayload, setISPayload] = useState5({
    viewType: "SEARCH" /* SEARCH */,
    searchTerm: ""
  });
  const [searchTriggerRef, setSearchTriggerRef] = useState5();
  const [submitted, setSubmitted] = useState5(false);
  const handleClose = () => {
    setSearchInput(void 0);
    setSubmitted(false);
  };
  const handleSubmit = () => {
    setISPayload({
      searchTerm: (searchInput == null ? void 0 : searchInput.searchText) || "",
      viewType: "SEARCH" /* SEARCH */
    });
    setSubmitted(true);
    onToggleISEngaged == null ? void 0 : onToggleISEngaged((searchInput == null ? void 0 : searchInput.searchType) === "CONTEXTUAL_FOLLOW_UP" /* CONTEXTUAL_FOLLOW_UP */);
  };
  const getSearchView = () => {
    if (!searchInput) {
      return null;
    }
    switch (searchInput.searchType) {
      case "CONTEXTUAL_FOLLOW_UP" /* CONTEXTUAL_FOLLOW_UP */:
        return /* @__PURE__ */React46.createElement(IntelligentSearch, {
          isPayload,
          onClick: setISPayload
        });
      default:
        return /* @__PURE__ */React46.createElement(GenericArticleSearch, {
          searchTerm: searchInput.searchText,
          onClose: handleClose,
          triggerRef: searchTriggerRef
        });
    }
  };
  return /* @__PURE__ */React46.createElement("div", {
    "data-stid": "help-center-search"
  }, (searchInput == null ? void 0 : searchInput.intelligentSearchBackButton) && submitted && searchInput.searchType === "CONTEXTUAL_FOLLOW_UP" /* CONTEXTUAL_FOLLOW_UP */ && /* @__PURE__ */React46.createElement(Viewport4, null, /* @__PURE__ */React46.createElement(ViewMedium3, null, /* @__PURE__ */React46.createElement(React46.Fragment, null, /* @__PURE__ */React46.createElement(EGDSSpacing8, {
    margin: {
      blockstart: "twelve",
      blockend: "eight"
    }
  }, /* @__PURE__ */React46.createElement(HelpCenterEGDSButton, {
    "aria-label": "intelligent search back button",
    "data-testid": "intelligent-search-back-button",
    data: searchInput.intelligentSearchBackButton,
    type: "button",
    size: EGDSButtonSize7.MEDIUM,
    onClickHandler: () => {
      handleClose();
      onToggleISEngaged == null ? void 0 : onToggleISEngaged(false);
    }
  })), /* @__PURE__ */React46.createElement(HelpCenterEGDSHeading, {
    data: {
      __typename: "EGDSHeading",
      text: (_a = searchInput.title) != null ? _a : "",
      headingType: "H4" /* H4 */
    },
    size: 4,
    margin: {
      blockend: "four"
    }
  }))), /* @__PURE__ */React46.createElement(ViewSmall4, null, /* @__PURE__ */React46.createElement(EGDSToolbar, {
    "data-testid": "intelligent-search-tool-bar",
    navigationContent: {
      onClick: () => {
        handleClose();
        onToggleISEngaged == null ? void 0 : onToggleISEngaged(false);
      },
      navIconLabel: "Go back",
      navType: "back"
    },
    toolbarTitle: (_b = searchInput.title) != null ? _b : " "
  }))), /* @__PURE__ */React46.createElement(ArticleContextProvider2, {
    dialogId: "search-article-dialog"
  }, /* @__PURE__ */React46.createElement(SearchInput, {
    onSubmit: handleSubmit,
    onChange: setSearchInput,
    ssr,
    value: searchInput == null ? void 0 : searchInput.searchText,
    onSearchTriggerRef: setSearchTriggerRef
  }), submitted && getSearchView()));
};
export { HelpCenterSearch };
/* istanbul ignore file -- @preserve */
//# sourceMappingURL=index.js.map